"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3610],{

/***/ 54027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5779);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



const MiniNav = (param)=>{
    let { className , navItems , stage , disabled , setStage  } = param;
    const selectedIndex = navItems.findIndex((items)=>{
        return items.targetStage === (stage === null || stage === void 0 ? void 0 : stage.stage);
    });
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
    const isLight = theme.type === "LIGHT";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex items-center my-6 py-2 pb-6 cursor-pointer ".concat(navItems.length < 2 ? "justify-center" : "", " ").concat(className !== null && className !== void 0 ? className : "sm:pl-[35%] sm:pr-[35%] mt-20"),
        children: navItems.filter((i)=>{
            return !!stage && (stage === null || stage === void 0 ? void 0 : stage.skipPreview) && i.label === "Preview" ? false : true;
        }).map((item, index, items)=>{
            const isHighlighted = index <= selectedIndex;
            const isActive = index === selectedIndex;
            const { label , targetStage  } = item;
            const offTextColor = isLight ? "text-black" : "text-white";
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center",
                        onClick: ()=>{
                            if (!disabled && !isActive) {
                                setStage({
                                    stage: targetStage
                                });
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "\n                  w-9 h-9 rounded-full flex items-center justify-center text-xs\n                  ".concat(isHighlighted ? "bg-forumm-blue-light text-black" : "border border-forumm-gray " + offTextColor, "\n                  ").concat(isActive ? "outer-circle" : "", "\n                "),
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "absolute text-xs mt-11 text-center",
                                children: isActive ? label : label.split(" ").map((name, i)=>i > 0 ? name.slice(0, 1) : name).join(" .")
                            })
                        ]
                    }),
                    index < items.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 ".concat(index < selectedIndex ? "bg-forumm-blue-light" : "bg-forumm-gray", " h-px")
                    })
                ]
            }, "mininav-item-".concat(item.label));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MiniNav);


/***/ }),

/***/ 45289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39618);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5434);





const AdditionalAttendeesStep = (param)=>{
    let { activeAdditionalTickets , attendeesError , disableFormProgress , errors , errorHandler , getEmail , labelBgColour , onBack , onContinue , onTicketChange , saving , setAttendeesError , textColour  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "mb-2 text-lg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdOutlineQuiz */ .OWq, {
                        className: "inline-block w-8 h-8 mr-1"
                    }),
                    " Attendee Information"
                ]
            }),
            activeAdditionalTickets === null || activeAdditionalTickets === void 0 ? void 0 : activeAdditionalTickets.map((attendee, index)=>{
                var ref;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    className: "mb-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                            className: "mt-1 mb-2",
                            children: "Additional Attendee ".concat(index + 1)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o, {
                            validations: {
                                minLength: {
                                    value: 1,
                                    message: "Field name must be at least 1 character"
                                },
                                maxLength: {
                                    value: 70,
                                    message: "Field name must be at most 70 characters"
                                }
                            },
                            required: true,
                            value: attendee.fullName,
                            onChange: (value)=>onTicketChange(index, {
                                    fullName: value
                                }),
                            label: "Full Name",
                            placeholder: "Enter additional attendee ".concat(index + 1, "'s full name")
                        }, index),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o, {
                            validations: {
                                isUnique: {
                                    value: [
                                        getEmail(),
                                        ...activeAdditionalTickets.map((additionalAttendee, additionalAttendeeIndex)=>additionalAttendeeIndex === index ? "" : additionalAttendee.email).filter((email)=>!!email && email !== "")
                                    ],
                                    message: "You must provide a unique email for each ticket"
                                },
                                minLength: {
                                    value: 7,
                                    message: "Email must be at least 7 characters"
                                },
                                maxLength: {
                                    value: 70,
                                    message: "Email must be less than 70 characters"
                                },
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Email must be valid"
                                }
                            },
                            setError: errorHandler("Attendee Information"),
                            error: (ref = errors.find((error)=>error.eleId === "additional_attendee_email_".concat(index))) === null || ref === void 0 ? void 0 : ref.message,
                            onChange: (value)=>onTicketChange(index, {
                                    email: value
                                }),
                            required: true,
                            value: attendee.email,
                            type: "email",
                            label: "Email",
                            testid: "additional_attendee_email_".concat(index),
                            placeholder: "Enter additional attendee ".concat(index + 1, "'s email"),
                            textColour: textColour,
                            labelBgColour: labelBgColour
                        })
                    ]
                }, "additional_ticket_info_".concat(index + 1));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "mt-4 text-center text-red-500 text-xs",
                children: attendeesError
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "flex w-full mt-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                        title: "Back",
                        className: "flex-2 mr-2",
                        buttonType: "submit",
                        onClick: onBack
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                        disabled: disableFormProgress,
                        title: "Continue",
                        className: "flex-[8] !text-white",
                        textColor: !disableFormProgress ? "white" : undefined,
                        buttonType: "submit",
                        onClick: ()=>{
                            setAttendeesError("");
                            onContinue();
                        },
                        loading: saving
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdditionalAttendeesStep);


/***/ }),

/***/ 32277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39618);



const nameValidations = (label)=>({
        minLength: {
            value: 1,
            message: "".concat(label, " must be at least 1 characters")
        },
        maxLength: {
            value: 70,
            message: "".concat(label, " must be less than 70 characters")
        },
        pattern: {
            value: /^[a-z ,.'-]+$/i,
            message: "Name must consist of letters only"
        }
    });
const emailValidations = {
    minLength: {
        value: 7,
        message: "Email must be at least 7 characters"
    },
    maxLength: {
        value: 70,
        message: "Email must be less than 70 characters"
    },
    pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: "Email must be valid"
    }
};
const passwordValidations = {
    minLength: {
        value: 8,
        message: "Password is too short (minimum: 8 characters)"
    },
    maxLength: {
        value: 50,
        message: "Password is too long"
    }
};
const renderRegistrationAccountFields = (param)=>{
    let { confirmPasswordErrorStep ="confirm_password" , errors , errorHandler , hasAccount , labelBgColour , nameFieldsClassName ="flex flex-row items-center justify-between mb-0" , nameInputClassName , onConfirmPasswordChange , onEmailChange , onFirstNameChange , onLastNameChange , onPasswordChange , showConfirmPasswordField =!hasAccount , showNameFields , showPasswordField =true , signedIn , textColour  } = param;
    var ref, ref1;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                show: showNameFields,
                className: nameFieldsClassName,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_2__/* .TextInput */ .o, {
                        className: nameInputClassName,
                        required: !signedIn,
                        validations: nameValidations("First Name"),
                        onChange: onFirstNameChange,
                        label: "First Name",
                        placeholder: "Taylor",
                        textColour: textColour,
                        labelBgColour: labelBgColour
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_2__/* .TextInput */ .o, {
                        className: nameInputClassName,
                        required: !signedIn,
                        validations: nameValidations("Last Name"),
                        onChange: onLastNameChange,
                        label: "Last Name",
                        placeholder: "Swift",
                        textColour: textColour,
                        labelBgColour: labelBgColour
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_2__/* .TextInput */ .o, {
                validations: emailValidations,
                onChange: onEmailChange,
                required: !signedIn,
                error: (ref = errors.find((error)=>error.eleId === "PrimaryEmail")) === null || ref === void 0 ? void 0 : ref.message,
                label: "Email",
                type: "email",
                placeholder: "your@email.com",
                textColour: textColour,
                labelBgColour: labelBgColour
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_2__/* .TextInput */ .o, {
                placeholder: "Enter your password",
                type: "password",
                show: showPasswordField,
                setError: errorHandler("password"),
                validations: passwordValidations,
                ignoreDefaultValidations: hasAccount,
                onChange: onPasswordChange,
                required: !signedIn,
                label: "Password",
                textColour: textColour,
                labelBgColour: labelBgColour
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_2__/* .TextInput */ .o, {
                placeholder: "Confirm your password",
                type: "password",
                show: showConfirmPasswordField,
                setError: errorHandler("confirm_password"),
                error: (ref1 = errors.find((error)=>error.step === confirmPasswordErrorStep)) === null || ref1 === void 0 ? void 0 : ref1.message,
                validations: passwordValidations,
                ignoreDefaultValidations: hasAccount,
                onChange: onConfirmPasswordChange,
                required: !signedIn,
                label: "Confirm Password",
                textColour: textColour,
                labelBgColour: labelBgColour
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (renderRegistrationAccountFields);


/***/ }),

/***/ 81247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_base_MiniNav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54027);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_InputPicker_InputPicker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55369);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68240);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5434);







const RegistrationFieldsStep = (param)=>{
    let { allTicketsRegistrationFieldsAreFilled , alreadyJoined , attendeesToGetRegFields , event , fieldVals , hasAccount , onBack , onContinue , onRegistrationFieldChange , onRegistrationFieldNext , onRegistrationFieldPrevious , registrationFieldErrors , regFieldSelectedAttendee , saving , setRegFieldSelectedAttendee  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "mb-2 text-lg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_6__/* .MdOutlineQuiz */ .OWq, {
                        className: "inline-block w-8 h-8 mr-1"
                    }),
                    " Ticket Holder Information",
                    hasAccount && alreadyJoined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-xs pt-2 block",
                        children: "You have already joined this event. If you wish, you can go back and check the event`s front page for more details."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "size-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_MiniNav__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "w-full sm:px-6 mb-6",
                        stage: regFieldSelectedAttendee,
                        setStage: (data)=>{
                            setRegFieldSelectedAttendee({
                                ...regFieldSelectedAttendee,
                                ...data
                            });
                        },
                        navItems: attendeesToGetRegFields.map((attendee, index)=>({
                                label: attendee.fullName,
                                targetStage: index
                            }))
                    }),
                    attendeesToGetRegFields.map((attendee, attendeeIndex, attendees)=>{
                        var ref;
                        const attendeeKey = "".concat(attendee.fullName, "::").concat(attendee.email).trim().toLowerCase().replaceAll(" ", "_");
                        const isSelected = (regFieldSelectedAttendee === null || regFieldSelectedAttendee === void 0 ? void 0 : regFieldSelectedAttendee.stage) === attendeeIndex;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                            children: [
                                event === null || event === void 0 ? void 0 : (ref = event.registrationFields) === null || ref === void 0 ? void 0 : ref.map((field)=>{
                                    var ref;
                                    const fieldName = "".concat(attendeeIndex, "::").concat(field.name.replaceAll(" ", "_").toLowerCase());
                                    var _type, _dateOnly, _required, _options;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        show: isSelected,
                                        className: "mb-8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_InputPicker_InputPicker__WEBPACK_IMPORTED_MODULE_4__/* .InputPicker */ .X, {
                                            ukey: "registration_field_input_".concat(attendeeKey),
                                            type: (_type = field.type) !== null && _type !== void 0 ? _type : _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .FormInputType.Text */ .Tx.Text,
                                            dateOnly: (_dateOnly = field.dateOnly) !== null && _dateOnly !== void 0 ? _dateOnly : false,
                                            validations: {
                                                minLength: {
                                                    value: 1,
                                                    message: "Field name must be at least 1 character"
                                                }
                                            },
                                            value: fieldVals === null || fieldVals === void 0 ? void 0 : (ref = fieldVals[attendeeIndex]) === null || ref === void 0 ? void 0 : ref[field.name],
                                            onChange: (value)=>onRegistrationFieldChange(attendeeIndex, field.name, value),
                                            required: (_required = field.required) !== null && _required !== void 0 ? _required : false,
                                            label: field.name,
                                            placeholder: field.name,
                                            options: (_options = field.options) !== null && _options !== void 0 ? _options : [],
                                            error: registrationFieldErrors === null || registrationFieldErrors === void 0 ? void 0 : registrationFieldErrors[fieldName],
                                            outputFormat: "string"
                                        })
                                    }, fieldName);
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    show: isSelected,
                                    className: "flex w-full justify-between items-center mt-4 mb-10",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                            className: "mr-auto",
                                            show: (regFieldSelectedAttendee === null || regFieldSelectedAttendee === void 0 ? void 0 : regFieldSelectedAttendee.stage) !== 0,
                                            type: "square",
                                            title: "Previous",
                                            onClick: ()=>onRegistrationFieldPrevious(attendeeIndex)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                            className: "ml-auto",
                                            show: (regFieldSelectedAttendee === null || regFieldSelectedAttendee === void 0 ? void 0 : regFieldSelectedAttendee.stage) !== attendees.length - 1,
                                            type: "square",
                                            title: "Next",
                                            onClick: ()=>onRegistrationFieldNext(attendeeIndex, attendees.length)
                                        })
                                    ]
                                })
                            ]
                        }, attendeeKey);
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "flex w-full mt-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                        title: "Back",
                        className: "flex-2 mr-2",
                        buttonType: "submit",
                        onClick: onBack
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                        disabled: !allTicketsRegistrationFieldsAreFilled,
                        title: "Continue",
                        className: "flex-[8]",
                        textColor: "white",
                        buttonType: "submit",
                        onClick: onContinue,
                        loading: saving
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RegistrationFieldsStep);


/***/ }),

/***/ 33959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ useEventRegistration; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/base/GoogleTags.tsx
var GoogleTags = __webpack_require__(507);
// EXTERNAL MODULE: ./graphql/events/GetEventById.ts
var GetEventById = __webpack_require__(87755);
// EXTERNAL MODULE: ./graphql/events/GetEventByIdForUnregisteredUser.ts
var GetEventByIdForUnregisteredUser = __webpack_require__(34975);
// EXTERNAL MODULE: ./graphql/events/GetEventByDonationUrl.ts
var GetEventByDonationUrl = __webpack_require__(95746);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
;// CONCATENATED MODULE: ./graphql/events/purchaseTickets.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation PurchaseTickets(\n    $input: PurchaseTicketsInput!\n    $donation: DonationInput\n  ) {\n    purchaseTickets(input: $input, donation: $donation) {\n      checkoutUrl\n      checkoutClientSecret\n      checkoutSessionId\n      checkoutStripeAccountId\n      checkoutPresentation\n      paymentProcessor\n      paymentStatus\n      orderId\n      user\n      userAlreadyExist\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const PURCHASE_TICKETS = (0,lib/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./graphql/events/checkDiscountCode.ts

function checkDiscountCode_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CheckDiscountCode(\n    $eventId: String!\n    $ticketName: String!\n    $code: String!\n  ) {\n    checkDiscountCode(eventId: $eventId, ticketName: $ticketName, code: $code) {\n      type\n      success\n      discountTitle\n      percentage\n      amount\n    }\n  }\n"
    ]);
    checkDiscountCode_templateObject = function() {
        return data;
    };
    return data;
}

const CHECK_DISCOUNT_CODE = (0,lib/* gql */.Ps)(checkDiscountCode_templateObject());

// EXTERNAL MODULE: ./graphql/__generated/graphql.ts
var graphql = __webpack_require__(68240);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/users/getUserStatus.ts

const GET_USER_STATUS = (0,_generated/* graphql */.B)("\n  query getUserStatus($email: String!) {\n    getUserStatus(email: $email) {\n      exists\n    }\n  }\n");

// EXTERNAL MODULE: ./libs/currencies.ts
var currencies = __webpack_require__(30530);
;// CONCATENATED MODULE: ./libs/Event/util.ts
const formatError = (ident, err)=>console.error("[".concat(ident !== null && ident !== void 0 ? ident : "EventUtil", "]: ").concat(err));
const getAvailableTickets = (event)=>{
    var ref;
    const payload = [];
    var ref1;
    return (ref1 = event === null || event === void 0 ? void 0 : (ref = event.availableTickets) === null || ref === void 0 ? void 0 : ref.tickets) !== null && ref1 !== void 0 ? ref1 : [];
    try {
        var ref2, ref3;
        event === null || event === void 0 ? void 0 : (ref2 = event.availableTickets) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.tickets) === null || ref3 === void 0 ? void 0 : ref3.forEach((t)=>{
            if (t && t.remaining && parseInt(t.remaining) > 0) payload.push(t);
        });
    } catch (err) {
        formatError("GetAvailableTickets", err);
    }
    return payload;
};

// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
// EXTERNAL MODULE: ./libs/useLocalStorage.tsx
var useLocalStorage = __webpack_require__(3830);
// EXTERNAL MODULE: ./libs/useOrganisationProfile.ts
var useOrganisationProfile = __webpack_require__(19058);
// EXTERNAL MODULE: ./libs/useStatistics.ts
var useStatistics = __webpack_require__(23638);
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
// EXTERNAL MODULE: ./libs/Utility/register.util.ts
var register_util = __webpack_require__(49981);
// EXTERNAL MODULE: ./libs/Utility/util.ts + 2 modules
var util = __webpack_require__(52229);
// EXTERNAL MODULE: ./libs/Utility/validation.ts
var validation = __webpack_require__(49532);
// EXTERNAL MODULE: ./components/inputs/Validations.tsx
var Validations = __webpack_require__(6686);
// EXTERNAL MODULE: ./node_modules/@stripe/stripe-js/dist/stripe.esm.js
var stripe_esm = __webpack_require__(91291);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./pages/event/[eventId]/index.tsx + 21 modules
var _eventId_ = __webpack_require__(14304);
;// CONCATENATED MODULE: ./components/event/register/useEventRegistration.tsx
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];



























const stripePublicKey = "pk_live_jP3Sfq8LMnLnup6TR2O9tA6u";
const normalizeEmail = (value)=>{
    return value === null || value === void 0 ? void 0 : value.trim().toLowerCase();
};
const useEventRegistration = function() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    const router = (0,next_router.useRouter)();
    const statisticId = (0,useStatistics/* default */.Z)();
    var ref17, ref18;
    const userData = (0,lodash.isArray)(router.query.ud) ? ((ref17 = router.query.ud[0]) !== null && ref17 !== void 0 ? ref17 : "").trim().replace(" ", "+") : ((ref18 = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.ud) !== null && ref18 !== void 0 ? ref18 : "").trim().replace(" ", "+");
    const discountParam = (0,lodash.isArray)(router.query.dcu) ? router.query.dcu[0] : router.query.dcu;
    const discountedUrl = discountParam ? Buffer.from(discountParam.trim().replace(/ /g, "+"), "base64").toString() : undefined;
    const { getSession , signInWithEmail , signInWithGoogle , signInWithLinkedIn , profile , getPermission  } = (0,useAuth/* useAuth */.aC)();
    const [purchaseTickets] = (0,useMutation/* useMutation */.D)(PURCHASE_TICKETS);
    const [email, setEmail] = (0,react.useState)();
    const [password, setPassword] = (0,react.useState)();
    const [confirmPassword, setConfirmPassword] = (0,react.useState)();
    const [firstName, setFirstName] = (0,react.useState)();
    const [lastName, setLastName] = (0,react.useState)();
    // Flag: indicates if the user already has an account.
    const [hasAccount, setHasAccount] = (0,react.useState)(false);
    const [isNewLogin, setIsNewLogin] = (0,react.useState)();
    const [clearForm, setClearForm] = (0,react.useState)(false);
    const eventId = (0,register_util/* resolveRegistrationEventId */.Fb)(router.query.eventId, _eventId_.eventIdsMap);
    const [ticketPersist, setTicketPersist] = (0,useLocalStorage/* default */.Z)("Forumm_Registration_Data", {});
    const [redirectTarget, setRedirectTarget] = (0,useLocalStorage/* default */.Z)("Forumm_redirect_target", undefined);
    const setEventRedirectTarget = ()=>{
        var ref;
        var ref1;
        setRedirectTarget({
            path: router.asPath,
            analyticsIntent: "buy_ticket",
            event: {
                eventId: eventId,
                title: (ref1 = event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.title) !== null && ref1 !== void 0 ? ref1 : "Event"
            }
        });
    };
    const handleGoogleSignIn = async ()=>{
        setEventRedirectTarget();
        await signInWithGoogle();
    };
    const handleLinkedInSignIn = async ()=>{
        setEventRedirectTarget();
        await signInWithLinkedIn();
    };
    const [ticketData, setTicketData] = (0,react.useState)({
        requiresAdditional: false,
        // additionalTickets: ticketPersist.additionalTickets
        //   ? new Array().fill('', 0, ticketPersist?.additionalTickets)
        //   : [],
        // discountCode: ticketPersist?.discountCode,
        additionalTickets: []
    });
    const [fieldVals, setFieldVals] = (0,react.useState)([]);
    const [errors, setErrors] = (0,react.useState)([]);
    const [attendeesError, setAttendeesError] = (0,react.useState)("");
    const [saving, setSaving] = (0,react.useState)(false);
    const [signedIn, setSignedIn] = (0,react.useState)(false);
    const authenticatedEmailRef = (0,react.useRef)();
    const authenticatedFullNameRef = (0,react.useRef)();
    const loginEventTrackedRef = (0,react.useRef)(false);
    const signInForRegistration = async (email, password)=>{
        const session = await signInWithEmail(email, password);
        if (!loginEventTrackedRef.current) {
            (0,GoogleTags/* pushFunnelLoginEvent */.Wz)("buy_ticket");
            loginEventTrackedRef.current = true;
        }
        return session;
    };
    const ticketFirstAccountGateRef = (0,react.useRef)(false);
    const [tab, setTab] = (0,react.useState)("Register");
    const [alreadyJoined, setAlreadyJoined] = (0,react.useState)(false);
    const [event, setEvent] = (0,react.useState)(undefined);
    const activeEventIdRef = (0,react.useRef)(eventId);
    const [accountError, setAccountError] = (0,react.useState)(false);
    const [regFieldSelectedAttendee, setRegFieldSelectedAttendee] = (0,react.useState)({
        stage: 0
    });
    const availableTickets = getAvailableTickets(event);
    const soleTicket = availableTickets.length === 1 ? availableTickets[0] : undefined;
    const soleTicketDetails = event === null || event === void 0 ? void 0 : (ref1 = event.tickets) === null || ref1 === void 0 ? void 0 : ref1.find((ticket)=>{
        var ref;
        return ticket.title.toUpperCase() === (soleTicket === null || soleTicket === void 0 ? void 0 : (ref = soleTicket.ticketTitle) === null || ref === void 0 ? void 0 : ref.toUpperCase());
    });
    var _remaining;
    const canAutoSelectSoleTicket = !!soleTicket && ((soleTicketDetails === null || soleTicketDetails === void 0 ? void 0 : soleTicketDetails.ticketType) === graphql/* TicketType.WaitingList */.zK.WaitingList || Number((_remaining = soleTicket.remaining) !== null && _remaining !== void 0 ? _remaining : 0) > 0);
    var ref19;
    const selectedTicketName = (ref2 = (ref19 = ticketData === null || ticketData === void 0 ? void 0 : ticketData.ticketName) !== null && ref19 !== void 0 ? ref19 : canAutoSelectSoleTicket ? soleTicket.ticketTitle : undefined) === null || ref2 === void 0 ? void 0 : ref2.toUpperCase();
    const selectedTicketNameForMultiple = selectedTicketName;
    const foundTicket = event === null || event === void 0 ? void 0 : (ref3 = event.tickets) === null || ref3 === void 0 ? void 0 : ref3.find((ticket)=>ticket.title.toUpperCase() === selectedTicketName);
    const foundTicketForMultiple = event === null || event === void 0 ? void 0 : (ref4 = event.tickets) === null || ref4 === void 0 ? void 0 : ref4.find((ticket)=>ticket.title.toUpperCase() === selectedTicketNameForMultiple);
    const foundAvailableTicketForMultiple = availableTickets.find((ticket)=>{
        var ref;
        return ((ref = ticket.ticketTitle) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === selectedTicketNameForMultiple;
    });
    var ref20;
    const selectedTicketAllowsMultiple = !!((ref20 = foundTicketForMultiple === null || foundTicketForMultiple === void 0 ? void 0 : foundTicketForMultiple.allowMultiplePurchase) !== null && ref20 !== void 0 ? ref20 : foundAvailableTicketForMultiple === null || foundAvailableTicketForMultiple === void 0 ? void 0 : foundAvailableTicketForMultiple.allowMultiplePurchase);
    const isGroupGuestTicket = (foundTicket === null || foundTicket === void 0 ? void 0 : foundTicket.ticketType) === graphql/* TicketType.GroupGuest */.zK.GroupGuest;
    var ref21;
    const maxAdditionalTickets = isGroupGuestTicket ? Math.max(0, Math.min(50, Number((ref21 = foundAvailableTicketForMultiple === null || foundAvailableTicketForMultiple === void 0 ? void 0 : foundAvailableTicketForMultiple.remaining) !== null && ref21 !== void 0 ? ref21 : 0) - 1)) : 4;
    const activeAdditionalTickets = ticketData.requiresAdditional && selectedTicketAllowsMultiple ? ticketData.additionalTickets : [];
    const requestedTicketCounts = {};
    if (selectedTicketName) {
        requestedTicketCounts[selectedTicketName] = 1 + (isGroupGuestTicket ? activeAdditionalTickets.length : 0);
        if (!isGroupGuestTicket) activeAdditionalTickets.forEach((ticket)=>{
            const title = ticket.title.toUpperCase();
            var _title;
            requestedTicketCounts[title] = ((_title = requestedTicketCounts[title]) !== null && _title !== void 0 ? _title : 0) + 1;
        });
    }
    const hasEnoughTickets = !!selectedTicketName && Object.entries(requestedTicketCounts).every((param)=>{
        let [title, quantity] = param;
        var ref;
        const ticketDetails = event === null || event === void 0 ? void 0 : (ref = event.tickets) === null || ref === void 0 ? void 0 : ref.find((ticket)=>ticket.title.toUpperCase() === title);
        if ((ticketDetails === null || ticketDetails === void 0 ? void 0 : ticketDetails.ticketType) === graphql/* TicketType.WaitingList */.zK.WaitingList) return true;
        const availability = availableTickets.find((ticket)=>{
            var ref;
            return ((ref = ticket.ticketTitle) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === title;
        });
        var ref1;
        return Number((ref1 = availability === null || availability === void 0 ? void 0 : availability.remaining) !== null && ref1 !== void 0 ? ref1 : 0) >= quantity;
    });
    const setMissingTicketError = ()=>{
        setErrors((state)=>[
                ...state.filter((error)=>error.eleId !== "ticketType"),
                {
                    eleId: "ticketType",
                    message: "Please select a ticket.",
                    step: "Register"
                }
            ]);
    };
    const [getEventForUnregisteredUser] = (0,useLazyQuery/* useLazyQuery */.t)(GetEventByIdForUnregisteredUser/* GET_EVENT_BY_ID_FOR_UNREGISTERED_USER */.A);
    const [getUserStatus] = (0,useLazyQuery/* useLazyQuery */.t)(GET_USER_STATUS);
    const [checkDiscountCode] = (0,useLazyQuery/* useLazyQuery */.t)(CHECK_DISCOUNT_CODE);
    const membershipAccess = getPermission("USER::MEMBERSHIP::*");
    var ref22;
    const hasMembership = membershipAccess.includes((ref22 = event === null || event === void 0 ? void 0 : (ref5 = event.event) === null || ref5 === void 0 ? void 0 : ref5.organizationName) !== null && ref22 !== void 0 ? ref22 : "*");
    const { data: fundraiseData  } = (0,useQuery/* useQuery */.a)(GetEventByDonationUrl/* GET_EVENT_BY_DONATION_URL */.I, {
        variables: {
            input: {
                donationUrl: event === null || event === void 0 ? void 0 : (ref6 = event.event) === null || ref6 === void 0 ? void 0 : ref6.donationUrl
            }
        },
        skip: !(event === null || event === void 0 ? void 0 : (ref7 = event.event) === null || ref7 === void 0 ? void 0 : ref7.donationUrl)
    });
    const fundraiseId = fundraiseData === null || fundraiseData === void 0 ? void 0 : (ref8 = fundraiseData.getEventByDonationUrl) === null || ref8 === void 0 ? void 0 : ref8.eventId;
    const fundraise = fundraiseData === null || fundraiseData === void 0 ? void 0 : (ref9 = fundraiseData.getEventByDonationUrl) === null || ref9 === void 0 ? void 0 : ref9.event;
    const fundraiseDetails = fundraiseData === null || fundraiseData === void 0 ? void 0 : (ref10 = fundraiseData.getEventByDonationUrl) === null || ref10 === void 0 ? void 0 : ref10.fundraising;
    var _title, ref23;
    const programmes = fundraise ? [
        {
            description: fundraise.description,
            goal: fundraiseDetails.goal,
            media: fundraiseDetails === null || fundraiseDetails === void 0 ? void 0 : (ref11 = fundraiseDetails.media) === null || ref11 === void 0 ? void 0 : ref11[0],
            title: (_title = fundraiseDetails.title) !== null && _title !== void 0 ? _title : "Main Fund"
        },
        ...(ref23 = fundraiseDetails === null || fundraiseDetails === void 0 ? void 0 : fundraiseDetails.programs) !== null && ref23 !== void 0 ? ref23 : []
    ] : [];
    const [donationData, setDonationData] = (0,react.useState)({
        enabled: false
    });
    const setAuthenticatedEmail = (value)=>{
        authenticatedEmailRef.current = normalizeEmail(value);
    };
    const getSessionAccountData = (session, fallbackEmail)=>{
        var ref, ref1, ref2, ref3;
        const payload = session === null || session === void 0 ? void 0 : (ref = session.getIdToken) === null || ref === void 0 ? void 0 : (ref1 = ref.call(session)) === null || ref1 === void 0 ? void 0 : ref1.payload;
        var ref4;
        const sessionEmail = (ref4 = payload === null || payload === void 0 ? void 0 : payload.email) !== null && ref4 !== void 0 ? ref4 : fallbackEmail;
        const fullName = (payload === null || payload === void 0 ? void 0 : (ref2 = payload["custom:fullName"]) === null || ref2 === void 0 ? void 0 : ref2.trim()) || (payload === null || payload === void 0 ? void 0 : (ref3 = payload.name) === null || ref3 === void 0 ? void 0 : ref3.trim()) || [
            payload === null || payload === void 0 ? void 0 : payload.given_name,
            payload === null || payload === void 0 ? void 0 : payload.family_name
        ].filter((name)=>{
            return !!(name === null || name === void 0 ? void 0 : name.trim());
        }).join(" ").trim();
        const [sessionFirstName, ...sessionLastName] = (fullName !== null && fullName !== void 0 ? fullName : "").split(" ").map((name)=>name.trim()).filter(Boolean);
        return {
            email: sessionEmail !== null && sessionEmail !== void 0 ? sessionEmail : undefined,
            firstName: sessionFirstName,
            lastName: sessionLastName.join(" ")
        };
    };
    const setAuthenticatedSession = (session, fallbackEmail)=>{
        const accountData = getSessionAccountData(session, fallbackEmail);
        const sessionEmail = accountData.email;
        setAuthenticatedEmail(sessionEmail);
        if (sessionEmail) setEmail(sessionEmail);
        setHasAccount(true);
        setSignedIn(true);
        const fullName = [
            accountData.firstName,
            accountData.lastName
        ].filter((name)=>{
            return !!(name === null || name === void 0 ? void 0 : name.trim());
        }).join(" ").trim();
        if (!fullName) return;
        authenticatedFullNameRef.current = fullName;
        setFirstName(accountData.firstName);
        setLastName(accountData.lastName);
    };
    const syncAuthenticatedSession = async ()=>{
        try {
            const session = await getSession();
            setAuthenticatedSession(session);
            return getSessionAccountData(session);
        } catch (error) {
            console.error("Unable to sync authenticated registration session:", error);
            return false;
        }
    };
    const getPrimaryFullName = (attendee, accountData)=>{
        var ref, ref1, ref2;
        var ref3, ref4;
        const formFullName = [
            (ref3 = accountData === null || accountData === void 0 ? void 0 : accountData.firstName) !== null && ref3 !== void 0 ? ref3 : firstName,
            (ref4 = accountData === null || accountData === void 0 ? void 0 : accountData.lastName) !== null && ref4 !== void 0 ? ref4 : lastName
        ].filter((name)=>{
            return !!(name === null || name === void 0 ? void 0 : name.trim());
        }).join(" ").trim();
        return (profile === null || profile === void 0 ? void 0 : (ref = profile.fullName) === null || ref === void 0 ? void 0 : ref.trim()) || ((ref1 = authenticatedFullNameRef.current) === null || ref1 === void 0 ? void 0 : ref1.trim()) || (attendee === null || attendee === void 0 ? void 0 : (ref2 = attendee.name) === null || ref2 === void 0 ? void 0 : ref2.trim()) || formFullName || undefined;
    };
    const isAuthenticatedForCurrentEmail = (emailOverride)=>{
        const currentEmail = normalizeEmail(emailOverride !== null && emailOverride !== void 0 ? emailOverride : email);
        const profileEmail = normalizeEmail(profile === null || profile === void 0 ? void 0 : profile.email);
        return signedIn || !!currentEmail && authenticatedEmailRef.current === currentEmail || !!currentEmail && !!profileEmail && profileEmail === currentEmail;
    };
    const { loading , data  } = (0,useQuery/* useQuery */.a)(GetEventById/* GET_EVENT_BY_ID */.p, {
        variables: {
            input: {
                eventId: eventId
            }
        },
        skip: !router.query.eventId || !!userData && !profile
    });
    (0,react.useEffect)(()=>{
        activeEventIdRef.current = eventId;
        setEvent((currentEvent)=>{
            return (currentEvent === null || currentEvent === void 0 ? void 0 : currentEvent.eventId) === eventId ? currentEvent : undefined;
        });
    }, [
        eventId
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if (ticketData.discountCode && ((ref = ticketData.discountCode) === null || ref === void 0 ? void 0 : ref.length) > 0) checkDiscount(ticketData.discountCode);
        else setTicketData((state)=>({
                ...state,
                discountValid: undefined
            }));
    // console.log({ ticketData })
    }, [
        ticketData.discountCode,
        ticketData.ticketName,
        activeAdditionalTickets.length,
        ticketData.requiresAdditional
    ]);
    (0,react.useEffect)(()=>{
        if (errors.filter((f)=>f.eleId === "discountCode").length > 0) {
            if (!ticketData.discountCode || ticketData.discountCode === "") setErrors((state)=>[
                    ...state.filter((f)=>f.eleId !== "discountCode")
                ]);
        }
    }, [
        errors,
        ticketData.discountCode
    ]);
    (0,react.useEffect)(()=>{
        if (profile) setSignedIn(true);
        if ((tab === "prompt" || tab === "Account") && (signedIn || !!profile)) setTab("Register");
    }, [
        profile,
        hasAccount,
        isNewLogin,
        signedIn,
        tab
    ]);
    (0,react.useEffect)(()=>{
        setClearForm(hasAccount);
        if (!hasAccount) {
            authenticatedEmailRef.current = undefined;
            authenticatedFullNameRef.current = undefined;
            if (!profile) setSignedIn(false);
        }
    }, [
        hasAccount,
        profile
    ]);
    (0,react.useEffect)(()=>{
        console.log("[Registration]: Current Tab<".concat(tab, ">."));
    }, [
        tab
    ]);
    (0,react.useEffect)(()=>{
        if (!hasAccount) checkEmail(email);
        else setErrors((state)=>[
                ...state.filter((e)=>e.eleId !== "PrimaryEmail")
            ]);
    }, [
        hasAccount,
        isNewLogin
    ]);
    (0,react.useEffect)(()=>{
        const queriedEvent = data === null || data === void 0 ? void 0 : data.getEventById;
        if (queriedEvent) {
            if (queriedEvent.eventId === activeEventIdRef.current) setEvent(queriedEvent);
            return;
        }
        if (!data && eventId && userData && !profile) {
            const requestedEventId = eventId;
            getEventForUnregisteredUser({
                variables: {
                    input: {
                        eventId: eventId,
                        userEmail: encodeURIComponent(userData)
                    }
                }
            }).then((d)=>{
                var ref;
                const queriedEvent = (ref = d.data) === null || ref === void 0 ? void 0 : ref.getEventByIdForUnregisteredUser;
                if ((queriedEvent === null || queriedEvent === void 0 ? void 0 : queriedEvent.eventId) === requestedEventId && requestedEventId === activeEventIdRef.current) setEvent(queriedEvent);
                if (d.error) router.push("/");
            });
        }
    }, [
        data,
        eventId,
        userData
    ]);
    (0,react.useEffect)(()=>{
        if (!event) return;
        if (tab === "prompt" && !(0,register_util/* getRegistrationConfig */.rS)(register_util/* CONFIG_OPTIONS.SHOW_ACCOUNT_PROMPT */.ce.SHOW_ACCOUNT_PROMPT, event)) setTab(signedIn || profile ? "Register" : "Account");
    }, [
        event
    ]);
    var ref24;
    const currency = currencies/* default */.Z[(ref24 = event === null || event === void 0 ? void 0 : (ref12 = event.event) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.currency) === null || ref13 === void 0 ? void 0 : ref13.toUpperCase()) !== null && ref24 !== void 0 ? ref24 : "GBP"];
    const { refreshTheme , theme  } = (0,useTheme/* useTheme */.Fg)();
    // dynamic stripe account loadin
    const [stripePromise, setStripePromise] = (0,react.useState)(null);
    const [merchantNotConfigured, setMerchantNotConfigured] = (0,react.useState)(false);
    const [loadingMerchantInfo, setLoadingMerchantInfo] = (0,react.useState)(true);
    const { profile: organisationProfile  } = (0,useOrganisationProfile/* useOrganisationProfile */.k)((event === null || event === void 0 ? void 0 : (ref14 = event.event) === null || ref14 === void 0 ? void 0 : ref14.organizationName) || "");
    const stripeReady = !merchantNotConfigured && !loadingMerchantInfo;
    // dynamic stripe account loadin
    (0,react.useEffect)(()=>{
        if (organisationProfile === null || organisationProfile === void 0 ? void 0 : organisationProfile.name) {
            setLoadingMerchantInfo(false);
            if (organisationProfile === null || organisationProfile === void 0 ? void 0 : organisationProfile.merchant) {
                const stripeAccount = organisationProfile.merchant;
                setStripePromise((0,stripe_esm/* loadStripe */.J)(stripePublicKey, {
                    stripeAccount
                }));
            } else {
                setMerchantNotConfigured(true);
            }
        }
    }, [
        organisationProfile
    ]);
    const isInvoiceTicket = (foundTicket === null || foundTicket === void 0 ? void 0 : foundTicket.ticketType) === graphql/* TicketType.InvoiceTicket */.zK.InvoiceTicket;
    var ref25, _length, _totalPrice;
    const invoiceTicketTotal = (_totalPrice = ticketData.totalPrice) !== null && _totalPrice !== void 0 ? _totalPrice : ((ref25 = foundTicket === null || foundTicket === void 0 ? void 0 : foundTicket.price) !== null && ref25 !== void 0 ? ref25 : 0) * (((_length = activeAdditionalTickets.length) !== null && _length !== void 0 ? _length : 0) + 1);
    (0,react.useEffect)(()=>{
        var _length;
        const quantity = ((event === null || event === void 0 ? void 0 : event.isPremium) && hasMembership ? 0 : 1) + ((_length = activeAdditionalTickets.length) !== null && _length !== void 0 ? _length : 0);
        var ref;
        const price = (ref = foundTicket === null || foundTicket === void 0 ? void 0 : foundTicket.price) !== null && ref !== void 0 ? ref : 0;
        let discount = 0;
        let totalPrice = price * quantity;
        if (ticketData.discountType === graphql/* DiscountType.Percentage */.Lb.Percentage) {
            var _discountPercentage;
            discount = price * (((_discountPercentage = ticketData.discountPercentage) !== null && _discountPercentage !== void 0 ? _discountPercentage : 0) / 100);
            totalPrice = (price - discount) * quantity;
        }
        if (ticketData.discountType === graphql/* DiscountType.Amount */.Lb.Amount) {
            var _discountAmount;
            discount = Math.min(price, (_discountAmount = ticketData.discountAmount) !== null && _discountAmount !== void 0 ? _discountAmount : 0);
            totalPrice = (price - discount) * quantity;
        }
        if (ticketData.discountType === graphql/* DiscountType.BuyOneGetOneFree */.Lb.BuyOneGetOneFree) {
            discount = Math.floor(quantity / 2) * price;
            totalPrice = price * quantity - discount;
        }
        const donationAmount = 0;
        // console.log({
        //   quantity,
        //   discount,
        //   price,
        //   donationAmount,
        //   type: ticketData.discountType,
        //   cond1: ticketData.discountType === DiscountType.Percentage,
        //   cond2: ticketData.discountType === DiscountType.BuyOneGetOneFree,
        // })
        setTicketData((prevTicketData)=>({
                ...prevTicketData,
                totalPrice: donationAmount + totalPrice
            }));
        if (ticketData.ticketName) setTicketPersist({
            ticketName: ticketData.ticketName,
            discountCode: ticketData.discountCode,
            additionalTickets: activeAdditionalTickets.length,
            eventId
        });
    }, [
        activeAdditionalTickets.length,
        ticketData.requiresAdditional,
        ticketData.ticketName,
        donationData.amount,
        ticketData.discountCode,
        ticketData.discountValid,
        ticketData.discountPercentage,
        ticketData.discountAmount
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if (canAutoSelectSoleTicket && ticketData.ticketName !== (soleTicket === null || soleTicket === void 0 ? void 0 : (ref = soleTicket.ticketTitle) === null || ref === void 0 ? void 0 : ref.toUpperCase())) {
            setTicketData((prevTicketData)=>{
                var ref;
                return {
                    ...prevTicketData,
                    ticketName: soleTicket === null || soleTicket === void 0 ? void 0 : (ref = soleTicket.ticketTitle) === null || ref === void 0 ? void 0 : ref.toUpperCase()
                };
            });
        }
    }, [
        canAutoSelectSoleTicket,
        soleTicket === null || soleTicket === void 0 ? void 0 : soleTicket.ticketTitle,
        ticketData.ticketName
    ]);
    (0,react.useEffect)(()=>{
        if (!!(ticketData === null || ticketData === void 0 ? void 0 : ticketData.ticketName) && !loading && !!event) {
            if (hasEnoughTickets) {
                setErrors((state)=>[
                        ...state.filter((f)=>f.eleId !== "TicketQuantity")
                    ]);
            } else {
                setErrors((state)=>[
                        ...state.filter((f)=>f.eleId !== "TicketQuantity"),
                        {
                            step: "Register",
                            eleId: "TicketQuantity",
                            message: "Not enough tickets remaining."
                        }
                    ]);
            }
        }
    }, [
        ticketData.ticketName,
        hasEnoughTickets,
        loading,
        event
    ]);
    (0,react.useEffect)(()=>{
        if (!!errors && errors.filter((f)=>f.step === "Account").length > 0) {
            return setTab("Account");
        }
        if (!!errors && errors.filter((f)=>f.step === "Register").length > 0) {
            return setTab("Register");
        }
    }, [
        errors
    ]);
    (0,react.useEffect)(()=>{
        if (!event) return;
        if (!(ticketPersist === null || ticketPersist === void 0 ? void 0 : ticketPersist.eventId) || ticketPersist.eventId !== eventId) setTicketPersist({});
        if (!discountedUrl && ticketPersist.eventId === eventId) {
            var ref;
            const foundTicket = event === null || event === void 0 ? void 0 : (ref = event.tickets) === null || ref === void 0 ? void 0 : ref.find((t)=>{
                var ref;
                return t.title.toUpperCase() === ((ref = ticketPersist.ticketName) === null || ref === void 0 ? void 0 : ref.toUpperCase());
            });
            if (foundTicket) {
                setTicketData((state)=>({
                        ...state,
                        ticketName: foundTicket.title
                    }));
            // if (ticketPersist.discountCode)
            //   checkDiscount(ticketPersist.discountCode)
            }
        }
        if (discountedUrl) {
            try {
                var ref1;
                const decodedDiscountData = JSON.parse(discountedUrl);
                const foundTicket1 = event === null || event === void 0 ? void 0 : (ref1 = event.tickets) === null || ref1 === void 0 ? void 0 : ref1.find((t)=>{
                    var ref;
                    return t.title.toUpperCase() === (decodedDiscountData === null || decodedDiscountData === void 0 ? void 0 : (ref = decodedDiscountData.name) === null || ref === void 0 ? void 0 : ref.toUpperCase());
                });
                if (foundTicket1) {
                    setTicketPersist({});
                    setTicketData((state)=>({
                            ...state,
                            ticketName: foundTicket1.title,
                            discountCode: decodedDiscountData.code,
                            discountValid: undefined,
                            discountType: undefined,
                            discountTitle: undefined,
                            discountPercentage: undefined
                        }));
                }
            } catch (err) {
                console.error(err);
            }
        }
    }, [
        discountedUrl,
        event === null || event === void 0 ? void 0 : event.tickets
    ]);
    const getEmail = (isAttendee, emailOverride)=>{
        if (profile && profile.email) return profile.email;
        if (isAttendee && isAttendee.email) return isAttendee.email;
        if (emailOverride !== "" && emailOverride !== undefined) return emailOverride;
        if (email !== "" && email !== undefined) return email;
        return null;
    };
    const ensureEnoughTickets = function() {
        let goToTab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : setTab, emailOverride = arguments.length > 1 ? arguments[1] : void 0;
        var ref, ref1;
        const purchaserEmail = normalizeEmail(emailOverride !== null && emailOverride !== void 0 ? emailOverride : email);
        const isExistingSpeaker = event === null || event === void 0 ? void 0 : (ref = event.speakers) === null || ref === void 0 ? void 0 : ref.some((speaker)=>!!purchaserEmail && normalizeEmail(speaker.email) === purchaserEmail);
        if ((event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : ref1.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser || isExistingSpeaker || hasEnoughTickets) return true;
        setErrors((state)=>[
                ...state.filter((error)=>error.eleId !== "TicketQuantity"),
                {
                    step: "Register",
                    eleId: "TicketQuantity",
                    message: "Not enough tickets remaining."
                }
            ]);
        goToTab("Register");
        setSaving(false);
        return false;
    };
    const submitTabEventDetails = async (donation, accountData)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        // If user has been added as an attendee, bypass stripe.
        if (saving) return;
        const loadedEventId = event === null || event === void 0 ? void 0 : event.eventId;
        if (!eventId || !loadedEventId || loadedEventId !== eventId) {
            setErrors([
                {
                    message: "The event changed while registration was in progress. Please refresh and try again.",
                    step: "request"
                }
            ]);
            setSaving(false);
            return;
        }
        var ref7;
        if (!ensureEnoughTickets(setTab, (ref7 = accountData === null || accountData === void 0 ? void 0 : accountData.email) !== null && ref7 !== void 0 ? ref7 : email)) return;
        setErrors([]);
        setSaving(true);
        var ref8;
        const submissionEmail = (ref8 = accountData === null || accountData === void 0 ? void 0 : accountData.email) !== null && ref8 !== void 0 ? ref8 : email;
        var ref9;
        const submissionPassword = (ref9 = accountData === null || accountData === void 0 ? void 0 : accountData.password) !== null && ref9 !== void 0 ? ref9 : password;
        const invalidPassword = (0,Validations/* validate */.G)(submissionPassword, {
            pattern: {
                value: validation/* PASSWORD_PATTERN */.mS,
                type: "match",
                message: "Password doesn&amp;t meet minimum requirements. 2 lowercase, 2 uppercase, 2 numbers, and 1 special character."
            }
        });
        if (invalidPassword) {
            setTab("Account");
            return setErrors((state)=>[
                    ...state.filter((f)=>f.step !== "Account"),
                    {
                        message: invalidPassword,
                        step: "Account"
                    }
                ]);
        }
        let redirectionUrl;
        const isAttendee = event === null || event === void 0 ? void 0 : (ref = event.attendees) === null || ref === void 0 ? void 0 : ref.find((s)=>{
            var ref;
            if (!submissionEmail) return false;
            const res = ((ref = s.email) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (submissionEmail === null || submissionEmail === void 0 ? void 0 : submissionEmail.toLowerCase());
            return res;
        });
        const isSpeaker = event === null || event === void 0 ? void 0 : (ref1 = event.speakers) === null || ref1 === void 0 ? void 0 : ref1.find((s)=>{
            var ref;
            if (!submissionEmail) return false;
            const res = ((ref = s.email) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (submissionEmail === null || submissionEmail === void 0 ? void 0 : submissionEmail.toLowerCase());
            return res;
        });
        const missingTicketSelection = !isAttendee && !isSpeaker && (event === null || event === void 0 ? void 0 : (ref2 = event.event) === null || ref2 === void 0 ? void 0 : ref2.eventType) !== graphql/* EventType.Fundraiser */.tw.Fundraiser && !selectedTicketName;
        const primaryFullName = getPrimaryFullName(isAttendee, accountData);
        if (!primaryFullName) {
            setErrors([
                {
                    message: "We could not load your profile details. Please refresh and try again.",
                    step: "Register"
                }
            ]);
            setTab("Register");
            setSaving(false);
            return;
        }
        if (missingTicketSelection) {
            setMissingTicketError();
            setTab("Register");
            setSaving(false);
            return;
        }
        const userMetadata = (ref3 = fieldVals && Array.isArray(fieldVals) ? fieldVals : [
            ...fieldVals
        ]) === null || ref3 === void 0 ? void 0 : ref3.map((fv)=>Object.keys(fv).map((key)=>({
                    name: key,
                    value: fv[key]
                })));
        if (isNewLogin && !signedIn) {
            const session = await signInForRegistration(submissionEmail, submissionPassword);
            setAuthenticatedSession(session, submissionEmail);
            setSaving(false);
            router.push("/event/".concat(router.query.eventId, "/register"));
            return;
        }
        const parsedTickets = ()=>{
            var ref;
            const mainTicket = {
                title: isAttendee && isAttendee.ticketTitle ? isAttendee.ticketTitle : isSpeaker ? "SPEAKER" : (event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser ? "FUNDRAISER_TICKET" : selectedTicketName,
                email: getEmail(isAttendee, submissionEmail),
                fullName: primaryFullName,
                registrationVisible: isRegistrationVisible,
                discountCode: (ticketData === null || ticketData === void 0 ? void 0 : ticketData.discountValid) ? ticketData === null || ticketData === void 0 ? void 0 : ticketData.discountCode : undefined
            };
            const getDiscount = (orderIndex)=>{
                const payload = (ticketData === null || ticketData === void 0 ? void 0 : ticketData.discountValid) ? ticketData === null || ticketData === void 0 ? void 0 : ticketData.discountCode : undefined;
                const nTickets = activeAdditionalTickets.length + 1;
                if (ticketData.discountType === graphql/* DiscountType.BuyOneGetOneFree */.Lb.BuyOneGetOneFree) {
                    const isPairedTicket = orderIndex < nTickets || orderIndex % 2 === 0;
                    if (!isPairedTicket) return undefined;
                }
                return payload;
            };
            const additionalTickets = isGroupGuestTicket ? [] : activeAdditionalTickets.map((t, i)=>{
                return {
                    title: t.title,
                    email: t.email,
                    fullName: t.fullName,
                    registrationFields: userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata[i + 1],
                    registrationVisible: isRegistrationVisible,
                    discountCode: getDiscount(i + 1)
                };
            });
            return [
                mainTicket,
                ...additionalTickets
            ];
        };
        const additionalFields = (userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata[0]) || [];
        const isAuthenticatedForSubmission = isAuthenticatedForCurrentEmail(submissionEmail);
        let bankPaymentPopup = null;
        var ref10;
        if (!isInvoiceTicket && options.embedCheckoutReturn && ((ref10 = ticketData === null || ticketData === void 0 ? void 0 : ticketData.totalPrice) !== null && ref10 !== void 0 ? ref10 : 0) > 0) {
            bankPaymentPopup = window.open.bind(window)("about:blank", "forumm-bank-payment", "popup,width=620,height=760,resizable=yes,scrollbars=yes");
            if (bankPaymentPopup) {
                bankPaymentPopup.document.title = "Preparing payment";
                bankPaymentPopup.document.body.textContent = "Preparing your secure payment...";
            }
        }
        try {
            var ref11, ref12;
            var ref13, ref14, ref15, _message, _selectedProgram;
            redirectionUrl = await purchaseTickets({
                variables: {
                    input: {
                        hasBalance: !isAttendee,
                        accountToCreate: isAuthenticatedForSubmission ? undefined : {
                            email: (ref13 = isAttendee === null || isAttendee === void 0 ? void 0 : isAttendee.email) !== null && ref13 !== void 0 ? ref13 : submissionEmail,
                            fullName: primaryFullName,
                            password: submissionPassword
                        },
                        eventId: loadedEventId,
                        tickets: parsedTickets(),
                        additionalGuestCount: isGroupGuestTicket ? activeAdditionalTickets.length : undefined,
                        userData: additionalFields,
                        embedCheckoutReturn: options.embedCheckoutReturn ? true : undefined,
                        embeddedCheckout: options.embedCheckoutReturn ? true : undefined
                    },
                    ...!!donation && (donationData === null || donationData === void 0 ? void 0 : donationData.enabled) ? {
                        donation: {
                            amount: donation.amount * 100,
                            firstName: (ref14 = accountData === null || accountData === void 0 ? void 0 : accountData.firstName) !== null && ref14 !== void 0 ? ref14 : firstName,
                            email: getEmail(isAttendee, submissionEmail),
                            organizationName: event === null || event === void 0 ? void 0 : (ref11 = event.event) === null || ref11 === void 0 ? void 0 : ref11.organizationName,
                            eventId: fundraiseId,
                            giftAid: !!donation.giftAid,
                            eventName: event === null || event === void 0 ? void 0 : (ref12 = event.event) === null || ref12 === void 0 ? void 0 : ref12.title,
                            currency: donation.currency,
                            lastName: (ref15 = accountData === null || accountData === void 0 ? void 0 : accountData.lastName) !== null && ref15 !== void 0 ? ref15 : lastName,
                            message: (_message = donation.message) !== null && _message !== void 0 ? _message : "",
                            selectedProgram: (_selectedProgram = donation.selectedProgram) !== null && _selectedProgram !== void 0 ? _selectedProgram : "",
                            statisticId: statisticId,
                            paymentType: donation.paymentType,
                            coverFee: donation.coverFee ? "true" : "false",
                            address: donation.address,
                            homeAddress: donation.homeAddress,
                            visibility: donation.visibility,
                            donorTitle: donation.donorTitle,
                            donorDob: donation.donorDob,
                            allowEmailContact: donation.allowEmailContact,
                            allowTelephoneContact: donation.allowTelephoneContact,
                            addressLine1: donation.addressLine1,
                            addressLine2: donation.addressLine2,
                            addressLine3: donation.addressLine3,
                            addressPostalCode: donation.addressPostalCode,
                            addressCity: donation.addressCity,
                            addressCountry: donation.addressCountry,
                            addressPhone: donation.addressPhone,
                            directDebitName: donation.directDebitName,
                            directDebitNumber: donation.directDebitNumber,
                            directDebitSort: donation.directDebitSort,
                            directDebitConfirmed: donation.directDebitConfirmed,
                            directDebitPeriod: donation.directDebitPeriod,
                            donation: donation.donation,
                            fee: donation.fee,
                            avatarUrl: donation.avatarUrl
                        }
                    } : {}
                }
            });
        } catch (error) {
            bankPaymentPopup === null || bankPaymentPopup === void 0 ? void 0 : bankPaymentPopup.close();
            var ref16;
            setErrors([
                {
                    message: (ref16 = error === null || error === void 0 ? void 0 : error.message) !== null && ref16 !== void 0 ? ref16 : "Unable to start payment.",
                    step: "request"
                }
            ]);
            setSaving(false);
            return;
        }
        setAccountError(false);
        const checkout = redirectionUrl === null || redirectionUrl === void 0 ? void 0 : (ref4 = redirectionUrl.data) === null || ref4 === void 0 ? void 0 : ref4.purchaseTickets;
        const checkoutUrl = checkout === null || checkout === void 0 ? void 0 : checkout.checkoutUrl;
        const checkoutClientSecret = checkout === null || checkout === void 0 ? void 0 : checkout.checkoutClientSecret;
        const checkoutSessionId = checkout === null || checkout === void 0 ? void 0 : checkout.checkoutSessionId;
        const checkoutStripeAccountId = checkout === null || checkout === void 0 ? void 0 : checkout.checkoutStripeAccountId;
        const checkoutPresentation = checkout === null || checkout === void 0 ? void 0 : checkout.checkoutPresentation;
        const paymentProcessor = checkout === null || checkout === void 0 ? void 0 : checkout.paymentProcessor;
        const userExists = checkout === null || checkout === void 0 ? void 0 : checkout.userAlreadyExist;
        if (checkoutUrl && checkoutUrl.includes("payment_error")) {
            if (!checkoutUrl.includes("error=")) {
                setErrors([
                    {
                        message: "An unexpected error has occured, please contact the site admin.",
                        step: "request"
                    }
                ]);
            }
            const errorCode = checkoutUrl.split("error=")[1];
            if (errorCode === "UserExists") {
                setAccountError(true);
                setErrors([
                    {
                        message: "Looks like you already have an account, please login before booking.",
                        step: "request"
                    }
                ]);
            }
            if (errorCode === "InvalidSetup") {
                setErrors([
                    {
                        message: "There was an issue with the event organiser.",
                        step: "request"
                    }
                ]);
            }
            bankPaymentPopup === null || bankPaymentPopup === void 0 ? void 0 : bankPaymentPopup.close();
            setSaving(false);
            return;
        }
        if (userExists) {
            bankPaymentPopup === null || bankPaymentPopup === void 0 ? void 0 : bankPaymentPopup.close();
            setAccountError(true);
            setErrors([
                {
                    message: "Looks like you already have an account, please login before booking.",
                    step: "request"
                }
            ]);
            setSaving(false);
            return;
        }
        if (!isAuthenticatedForSubmission && !!(redirectionUrl === null || redirectionUrl === void 0 ? void 0 : (ref5 = redirectionUrl.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.purchaseTickets) === null || ref6 === void 0 ? void 0 : ref6.user)) {
            const session1 = await signInForRegistration(submissionEmail, submissionPassword !== null && submissionPassword !== void 0 ? submissionPassword : JSON.parse(redirectionUrl.data.purchaseTickets.user).pass);
            setAuthenticatedSession(session1, submissionEmail);
        }
        if (checkoutClientSecret && options.embedCheckoutReturn) {
            var ref17;
            bankPaymentPopup === null || bankPaymentPopup === void 0 ? void 0 : bankPaymentPopup.close();
            (ref17 = window.parent) === null || ref17 === void 0 ? void 0 : ref17.postMessage({
                checkoutClientSecret,
                checkoutSessionId,
                checkoutStripeAccountId,
                eventId,
                stripePublishableKey: stripePublicKey !== null && stripePublicKey !== void 0 ? stripePublicKey : "",
                type: "FORUMM_EMBED_CHECKOUT_START"
            }, "*");
            setSaving(false);
            return;
        }
        if (checkoutUrl) {
            if (options.embedCheckoutReturn && paymentProcessor === "GOCARDLESS" && checkoutPresentation === "REDIRECT") {
                if (bankPaymentPopup) bankPaymentPopup.location.assign(checkoutUrl);
                else (0,util/* openInSameTab */.TG)(checkoutUrl);
            } else {
                bankPaymentPopup === null || bankPaymentPopup === void 0 ? void 0 : bankPaymentPopup.close();
                (0,util/* openInSameTab */.TG)(checkoutUrl);
            }
        } else {
            bankPaymentPopup === null || bankPaymentPopup === void 0 ? void 0 : bankPaymentPopup.close();
        }
        setSaving(false);
    };
    (0,react.useEffect)(()=>{
        if (event) {
            refreshTheme(event);
        }
        if (userData) setEmail(userData);
    }, [
        event,
        refreshTheme,
        userData
    ]);
    (0,react.useEffect)(()=>{
        if (profile === null || profile === void 0 ? void 0 : profile.userId) {
            setHasAccount(true);
        }
        if (!!(profile === null || profile === void 0 ? void 0 : profile.email) && !email) setEmail(profile.email);
    }, [
        profile
    ]);
    (0,react.useEffect)(()=>{
        if (profile && (event === null || event === void 0 ? void 0 : event.attendees)) {
            var ref;
            let hasJoined = (event === null || event === void 0 ? void 0 : event.attendees.filter((at)=>{
                var ref, ref1;
                return at.registered && ((ref = at.email) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (profile === null || profile === void 0 ? void 0 : (ref1 = profile.email) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase());
            }).length) > 0;
            if (!hasJoined && (event === null || event === void 0 ? void 0 : event.speakers) && event.speakers.length > 0) hasJoined = (event === null || event === void 0 ? void 0 : (ref = event.speakers) === null || ref === void 0 ? void 0 : ref.filter((f)=>{
                var ref, ref1;
                return ((ref = f.email) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (profile === null || profile === void 0 ? void 0 : (ref1 = profile.email) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase());
            }).length) > 0;
            setAlreadyJoined(hasJoined);
        }
    }, [
        profile,
        event
    ]);
    const [usersData] = (0,react.useState)([]);
    const [error, setError] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        getAttendeesToGetRegFields();
    }, [
        usersData
    ]);
    const [attendeesToGetRegFields, setAttendeesToGetRegFields] = (0,react.useState)([]);
    const [isRegistrationVisible, setIsRegistrationVisible] = (0,react.useState)(false);
    const getAttendeesToGetRegFields = ()=>{
        var ref;
        const payload = [
            {
                email: getEmail(),
                title: ticketData.ticketName,
                fullName: (ref = getPrimaryFullName()) !== null && ref !== void 0 ? ref : ""
            },
            ...isGroupGuestTicket ? [] : activeAdditionalTickets
        ];
        const user = payload[0];
        const isValid = (()=>{
            const currentStage = regFieldSelectedAttendee === null || regFieldSelectedAttendee === void 0 ? void 0 : regFieldSelectedAttendee.stage.toString();
            const allowedStages = payload.map((p)=>"".concat(p.fullName, "::").concat(p.email).trim().toLowerCase().replaceAll(" ", "_"));
            if (!currentStage) return false;
            return allowedStages.includes(currentStage);
        })();
        // console.log({ payload, user, regFieldSelectedAttendee, isValid })
        if (!!user.fullName && !!user.email && (!regFieldSelectedAttendee || regFieldSelectedAttendee.stage.toString().includes("undefined")) || !isValid) setAttendeesToGetRegFields(payload);
        return payload;
    };
    const errorHandler = function(id) {
        let alert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (message, testId)=>{
            const payload = [
                ...errors
            ];
            const hasError = !!message || message !== "";
            const isCleared = payload.find((f)=>f.eleId === testId) && !hasError;
            if (isCleared) return setErrors(payload.filter((f)=>f.eleId !== testId));
            const isDuplicate = !!payload.find((p)=>p.eleId === testId);
            const newError = {
                step: id !== null && id !== void 0 ? id : "unknown",
                message,
                eleId: testId,
                alert
            };
            if (!isDuplicate && hasError) setErrors([
                ...payload,
                newError
            ]);
        };
    };
    const totalTickets = isGroupGuestTicket ? 1 : activeAdditionalTickets.length + 1;
    var ref26;
    const fieldsToValidate = ((ref26 = event === null || event === void 0 ? void 0 : event.registrationFields) !== null && ref26 !== void 0 ? ref26 : []).filter((field)=>field.required === true).map((field)=>{
        return field === null || field === void 0 ? void 0 : field.name;
    });
    const allTicketsRegistrationFieldsAreFilled = (0,react.useMemo)(()=>{
        return (0,register_util/* areAllTicketRegistrationFieldsFilled */.vE)(fieldVals, totalTickets, fieldsToValidate);
    }, [
        fieldVals,
        totalTickets,
        fieldsToValidate
    ]);
    const disableFormProgress = (0,react.useMemo)(()=>{
        if (tab === "Attendee Information" && !isGroupGuestTicket) {
            if (errors.find((f)=>f.step === "Attendee Information")) return true;
            return activeAdditionalTickets.some((att)=>!att.fullName || !att.email);
        }
        return false;
    }, [
        tab,
        ticketData,
        activeAdditionalTickets,
        isGroupGuestTicket
    ]);
    const dynamicStyle = (0,util/* getDynamicStyle */.nT)(theme.highlightColour);
    const isDarkTheme = theme.type === "DARK";
    var ref27;
    const eventImage = (ref27 = event === null || event === void 0 ? void 0 : (ref15 = event.event) === null || ref15 === void 0 ? void 0 : ref15.bannerImage) !== null && ref27 !== void 0 ? ref27 : "https://assets.tumblr.com/images/default_header/optica_pattern_11.png";
    // console.log({ firstName, lastName })
    const organisationTrxFee = (organisationProfile === null || organisationProfile === void 0 ? void 0 : organisationProfile.percentage) !== undefined ? organisationProfile.percentage : 10;
    const handleAdditionalTickets = (val)=>{
        const requestedCount = Math.min(Math.max(val, 0), maxAdditionalTickets);
        var ref;
        setTicketData((state)=>{
            var ref1;
            return {
                ...state,
                requiresAdditional: requestedCount > 0 && selectedTicketAllowsMultiple,
                additionalTickets: (0,register_util/* getAdditionalTicketsForCount */.lx)({
                    currentTickets: state.requiresAdditional && selectedTicketAllowsMultiple ? state.additionalTickets : [],
                    requestedCount,
                    enabled: requestedCount > 0 && selectedTicketAllowsMultiple,
                    selectedTicketName: state.ticketName,
                    defaultTicketTitle: (ref = (ref1 = availableTickets[0]) === null || ref1 === void 0 ? void 0 : ref1.ticketTitle) !== null && ref !== void 0 ? ref : undefined
                })
            };
        });
    };
    const setRequiresAdditionalTickets = (requiresAdditional)=>{
        const canRequireAdditional = requiresAdditional && selectedTicketAllowsMultiple;
        if (!canRequireAdditional) {
            setAttendeesError("");
            setAttendeesToGetRegFields([]);
            setRegFieldSelectedAttendee({
                stage: 0
            });
            setFieldVals((state)=>state.slice(0, 1));
            setError((state)=>Object.fromEntries(Object.entries(state).filter((param)=>{
                    let [key] = param;
                    return key.startsWith("0::");
                })));
            setErrors((state)=>state.filter((error)=>error.step !== "Attendee Information"));
        }
        setTicketData((state)=>{
            const defaultTicketInfo = availableTickets[0];
            var _ticketName;
            const additionalTickets = !canRequireAdditional ? [] : state.additionalTickets.length < 1 && defaultTicketInfo ? [
                {
                    fullName: "",
                    title: (_ticketName = state.ticketName) !== null && _ticketName !== void 0 ? _ticketName : defaultTicketInfo.ticketTitle
                }
            ] : state.additionalTickets;
            return {
                ...state,
                requiresAdditional: canRequireAdditional,
                additionalTickets
            };
        });
    };
    const continueAfterTicketSelection = async (goToTab, accountData)=>{
        var ref, ref1, ref2;
        var ref3;
        const nextEmail = (ref3 = accountData === null || accountData === void 0 ? void 0 : accountData.email) !== null && ref3 !== void 0 ? ref3 : email;
        var ref4;
        const nextPassword = (ref4 = accountData === null || accountData === void 0 ? void 0 : accountData.password) !== null && ref4 !== void 0 ? ref4 : password;
        var ref5;
        const nextConfirmPassword = (ref5 = accountData === null || accountData === void 0 ? void 0 : accountData.confirmPassword) !== null && ref5 !== void 0 ? ref5 : confirmPassword;
        if (!ensureEnoughTickets(goToTab, nextEmail)) return;
        if (ticketData.requiresAdditional && activeAdditionalTickets.length < 1) {
            setRequiresAdditionalTickets(true);
        }
        getAttendeesToGetRegFields();
        if (!hasAccount && !!nextPassword && nextPassword !== nextConfirmPassword) {
            setErrors([
                {
                    step: "confirm_password",
                    message: "Please ensure that your given passwords match."
                }
            ]);
            return;
        }
        var ref6;
        const captureRegistrationFields = ((ref6 = (ref1 = event === null || event === void 0 ? void 0 : (ref = event.attendees) === null || ref === void 0 ? void 0 : ref.find((attendee)=>attendee.email === nextEmail)) === null || ref1 === void 0 ? void 0 : ref1.requireRegistrationFields) !== null && ref6 !== void 0 ? ref6 : true) || activeAdditionalTickets.length > 0;
        const hasRegistrationFields = !!(event === null || event === void 0 ? void 0 : event.registrationFields) && event.registrationFields.length > 0;
        if (ticketData.requiresAdditional && !isGroupGuestTicket) return goToTab("Attendee Information");
        var ref7;
        if ((((ref7 = event === null || event === void 0 ? void 0 : (ref2 = event.registrationFields) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref7 !== void 0 ? ref7 : 0) > 0 || fieldVals) && captureRegistrationFields && hasRegistrationFields) return goToTab("Event Details");
        return submitTabEventDetails(undefined, accountData);
    };
    const continueFromAccountStep = async function() {
        let { accountData , goToTab =setTab , onSignedIn , validatePasswordConfirmation =!hasAccount  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var ref;
        const submittedEmail = (ref = accountData === null || accountData === void 0 ? void 0 : accountData.email) !== null && ref !== void 0 ? ref : email;
        var ref1;
        const submittedPassword = (ref1 = accountData === null || accountData === void 0 ? void 0 : accountData.password) !== null && ref1 !== void 0 ? ref1 : password;
        var ref2;
        const submittedConfirmPassword = (ref2 = accountData === null || accountData === void 0 ? void 0 : accountData.confirmPassword) !== null && ref2 !== void 0 ? ref2 : confirmPassword;
        if (accountData) {
            var _firstName;
            setFirstName((_firstName = accountData.firstName) !== null && _firstName !== void 0 ? _firstName : firstName);
            var _lastName;
            setLastName((_lastName = accountData.lastName) !== null && _lastName !== void 0 ? _lastName : lastName);
            setEmail(submittedEmail);
            setPassword(submittedPassword);
            setConfirmPassword(submittedConfirmPassword);
        }
        setErrors([]);
        const shouldResumeTicketFlow = ticketFirstAccountGateRef.current;
        if (hasAccount && !!submittedEmail && !!submittedPassword) {
            try {
                const session = await signInForRegistration(submittedEmail, submittedPassword);
                setAuthenticatedSession(session, submittedEmail);
                setSaving(false);
                if (shouldResumeTicketFlow) {
                    ticketFirstAccountGateRef.current = false;
                    return continueAfterTicketSelection(goToTab, {
                        ...accountData,
                        email: submittedEmail,
                        password: submittedPassword
                    });
                }
                if (onSignedIn) onSignedIn();
                else goToTab("Register");
                return;
            } catch (_ex) {
                setSaving(false);
                setErrors([
                    {
                        step: "login",
                        message: "Incorrect email or password, please try again."
                    }
                ]);
                return;
            }
        }
        if (validatePasswordConfirmation) {
            const isValidPassword = submittedPassword === submittedConfirmPassword;
            if (!!submittedPassword && !isValidPassword) {
                setErrors([
                    {
                        step: "confirm_password",
                        message: "Please ensure that your given passwords match."
                    }
                ]);
                return;
            }
        }
        if (shouldResumeTicketFlow) {
            ticketFirstAccountGateRef.current = false;
            return continueAfterTicketSelection(goToTab, {
                ...accountData,
                confirmPassword: submittedConfirmPassword,
                email: submittedEmail,
                password: submittedPassword
            });
        }
        goToTab("Register");
    };
    const continueFromTicketStep = async function() {
        let { goToTab =setTab , onSignedIn  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var ref, ref1, ref2;
        if (!isAuthenticatedForCurrentEmail() && hasAccount && !!email && !!password) {
            try {
                const session = await signInForRegistration(email, password);
                setAuthenticatedSession(session, email);
                setSaving(false);
                if (onSignedIn) {
                    onSignedIn();
                    return;
                }
            } catch (_ex) {
                setSaving(false);
                setErrors([
                    {
                        step: "login",
                        message: "Incorrect email or password, please try again."
                    }
                ]);
                return;
            }
        }
        const hasCurrentAttendeeTicket = event === null || event === void 0 ? void 0 : (ref = event.attendees) === null || ref === void 0 ? void 0 : ref.some((attendee)=>{
            var ref;
            return !!email && ((ref = attendee.email) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === email.toLowerCase();
        });
        const hasCurrentSpeakerTicket = event === null || event === void 0 ? void 0 : (ref1 = event.speakers) === null || ref1 === void 0 ? void 0 : ref1.some((speaker)=>{
            var ref;
            return !!email && ((ref = speaker.email) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === email.toLowerCase();
        });
        const missingTicketSelection = !hasCurrentAttendeeTicket && !hasCurrentSpeakerTicket && (event === null || event === void 0 ? void 0 : (ref2 = event.event) === null || ref2 === void 0 ? void 0 : ref2.eventType) !== graphql/* EventType.Fundraiser */.tw.Fundraiser && !selectedTicketName;
        if (missingTicketSelection) {
            setMissingTicketError();
            goToTab("Register");
            return;
        }
        if (!ensureEnoughTickets(goToTab, email)) return;
        const hasAccountStepInput = !!(firstName || lastName || password || confirmPassword);
        if (!isAuthenticatedForCurrentEmail() && !hasAccountStepInput) {
            ticketFirstAccountGateRef.current = true;
            goToTab("Account");
            return;
        }
        ticketFirstAccountGateRef.current = false;
        return continueAfterTicketSelection(goToTab);
    };
    const videoUrl = (0,register_util/* getRegistrationVideoUrl */.PH)(event === null || event === void 0 ? void 0 : event.eventId);
    const validateRegistrationFields = (event, usersData, fieldVals, selectedAttendeeIndex)=>{
        const payload = (0,register_util/* getRegistrationFieldErrors */.jk)({
            event,
            usersData,
            fieldVals,
            selectedAttendeeIndex
        });
        const activeErrors = Object.values(payload).filter((p)=>!!p);
        if (activeErrors.length > 0) {
            setError((state)=>{
                return {
                    ...state !== null && state !== void 0 ? state : {},
                    ...payload
                };
            });
            return false;
        }
        return true;
    };
    const handleRegistrationFieldChange = (attendeeIndex, fieldName, value)=>{
        const payload = [
            ...fieldVals
        ];
        payload[attendeeIndex] = {
            ...payload[attendeeIndex],
            [fieldName]: value
        };
        const errorKey = "".concat(attendeeIndex, "::").concat(fieldName.replaceAll(" ", "_").toLowerCase());
        setError((state)=>{
            if (!(state === null || state === void 0 ? void 0 : state[errorKey])) return state;
            return {
                ...state,
                [errorKey]: undefined
            };
        });
        setFieldVals(payload);
    };
    const handleRegistrationFieldPrevious = (attendeeIndex)=>{
        if (attendeeIndex > 0) {
            setRegFieldSelectedAttendee({
                stage: attendeeIndex - 1
            });
        }
    };
    const handleRegistrationFieldNext = (attendeeIndex, attendeeCount)=>{
        const validRegFields = validateRegistrationFields(event, usersData, fieldVals, attendeeIndex);
        if (validRegFields && attendeeIndex < attendeeCount - 1) {
            setRegFieldSelectedAttendee({
                stage: attendeeIndex + 1
            });
        }
    };
    const checkDiscount = (0,react.useCallback)((0,util/* debounce */.Ds)(async (val)=>{
        await checkDiscountCode({
            variables: {
                eventId,
                ticketName: ticketData.ticketName,
                code: val
            },
            onCompleted: (data)=>{
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                setErrors((state)=>[
                        ...state.filter((f)=>f.eleId !== "discountCode")
                    ]);
                var ref9;
                const payload = {
                    discountValid: (ref9 = data === null || data === void 0 ? void 0 : (ref = data.checkDiscountCode) === null || ref === void 0 ? void 0 : ref.success) !== null && ref9 !== void 0 ? ref9 : false,
                    discountType: data === null || data === void 0 ? void 0 : (ref1 = data.checkDiscountCode) === null || ref1 === void 0 ? void 0 : ref1.type,
                    discountTitle: data === null || data === void 0 ? void 0 : (ref2 = data.checkDiscountCode) === null || ref2 === void 0 ? void 0 : ref2.discountTitle,
                    discountPercentage: data === null || data === void 0 ? void 0 : (ref3 = data.checkDiscountCode) === null || ref3 === void 0 ? void 0 : ref3.percentage,
                    discountAmount: data === null || data === void 0 ? void 0 : (ref4 = data.checkDiscountCode) === null || ref4 === void 0 ? void 0 : ref4.amount
                };
                setTicketData((state)=>({
                        ...state,
                        ...payload
                    }));
                const setDiscountError = (msg)=>setErrors((state)=>[
                            ...state.filter((f)=>f.eleId !== "discountCode"),
                            {
                                eleId: "discountCode",
                                message: msg,
                                step: "Register"
                            }
                        ]);
                if (payload.discountValid !== undefined && payload.discountValid === false) setDiscountError("Invalid discount code");
                const targetTicket = event === null || event === void 0 ? void 0 : (ref5 = event.availableTickets) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.tickets) === null || ref6 === void 0 ? void 0 : ref6.find((t)=>{
                    var ref, ref1;
                    return ((ref = ticketData.ticketName) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === ((ref1 = t.ticketTitle) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase());
                });
                const normalizedDiscountTitle = (ref7 = payload.discountTitle) === null || ref7 === void 0 ? void 0 : ref7.toUpperCase();
                const targetDiscount = targetTicket === null || targetTicket === void 0 ? void 0 : (ref8 = targetTicket.discountCodes) === null || ref8 === void 0 ? void 0 : ref8.find((f)=>!!normalizedDiscountTitle && f.title.toUpperCase() === normalizedDiscountTitle);
                const nDiscounts = (()=>{
                    let nTickets = activeAdditionalTickets.length + 1;
                    // Handle when an odd number of tickets are purchased using a 2-4-1 code.
                    if (payload.discountType === graphql/* DiscountType.BuyOneGetOneFree */.Lb.BuyOneGetOneFree) {
                        if (nTickets % 2 !== 0) nTickets -= 1;
                        return nTickets / 2;
                    }
                    return nTickets;
                })();
                var ref10;
                if (targetDiscount && ((ref10 = targetDiscount === null || targetDiscount === void 0 ? void 0 : targetDiscount.remaining) !== null && ref10 !== void 0 ? ref10 : 0) < nDiscounts) setDiscountError("Discount code usage limit reached");
            }
        });
    }, 1000), [
        ticketData.ticketName,
        activeAdditionalTickets.length,
        ticketData.requiresAdditional,
        event === null || event === void 0 ? void 0 : event.availableTickets
    ]);
    const checkEmail = (0,react.useCallback)((0,util/* debounce */.Ds)(async (val)=>{
        if (!!val) {
            await getUserStatus({
                variables: {
                    email: val
                },
                onCompleted: (res)=>{
                    var ref;
                    const result = res === null || res === void 0 ? void 0 : (ref = res.getUserStatus) === null || ref === void 0 ? void 0 : ref.exists;
                    if (result) setErrors((state)=>[
                            ...state,
                            {
                                step: "Account",
                                eleId: "PrimaryEmail",
                                message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "text-red-500 border-red-500 font-normal",
                                    ignoreTheme: true,
                                    children: [
                                        "Looks like you already have a Forumm account, try logging in",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold cursor-pointer",
                                            onClick: ()=>{
                                                setIsNewLogin(true);
                                                setHasAccount(true);
                                            },
                                            children: "here"
                                        }),
                                        "."
                                    ]
                                })
                            }
                        ]);
                    else setErrors((state)=>[
                            ...state.filter((e)=>e.eleId !== "PrimaryEmail")
                        ]);
                }
            });
        }
    }, 1000), []);
    const handleAdditionalTicketChange = (index, ticket)=>{
        setTicketData((state)=>{
            const payload = [
                ...state.additionalTickets
            ];
            payload[index] = {
                ...payload[index],
                ...ticket
            };
            return {
                ...state,
                additionalTickets: payload
            };
        });
    };
    const handleAdditionalAttendeesContinue = ()=>{
        var ref, ref1, ref2;
        if (!ensureEnoughTickets()) return;
        const attendeesIncompleted = activeAdditionalTickets.some((attendee)=>!attendee.fullName || !attendee.email);
        if (attendeesIncompleted) {
            setAttendeesError("Please complete the information of your additional attendees.");
            return;
        }
        var ref3;
        if (((ref3 = event === null || event === void 0 ? void 0 : (ref = event.registrationFields) === null || ref === void 0 ? void 0 : ref.length) !== null && ref3 !== void 0 ? ref3 : 0) > 0 || fieldVals) getAttendeesToGetRegFields();
        var ref4;
        // DOCS: Allows manually added attendees to skip the registration field capture step.
        const captureRegistrationFields = (ref4 = ((ref2 = event === null || event === void 0 ? void 0 : (ref1 = event.attendees) === null || ref1 === void 0 ? void 0 : ref1.find((attendee)=>attendee.email === email)) === null || ref2 === void 0 ? void 0 : ref2.requireRegistrationFields) || activeAdditionalTickets.length > 0) !== null && ref4 !== void 0 ? ref4 : true;
        const hasRegistrationFields = !!(event === null || event === void 0 ? void 0 : event.registrationFields) && event.registrationFields.length > 0;
        return captureRegistrationFields && hasRegistrationFields ? setTab("Event Details") : submitTabEventDetails();
    };
    const handleRegistrationFieldsContinue = ()=>{
        var ref, ref1;
        if (!ensureEnoughTickets()) return;
        const validRegFields = validateRegistrationFields(event, usersData, fieldVals);
        const errors = Object.keys(error).map((key)=>({
                key: key,
                message: error[key]
            }));
        var ref2;
        const errorStep = parseInt((ref2 = (ref1 = (ref = errors.find((entry)=>!!entry.message)) === null || ref === void 0 ? void 0 : ref.key.split("::")) === null || ref1 === void 0 ? void 0 : ref1[0]) !== null && ref2 !== void 0 ? ref2 : "0");
        const hasErrors = errors.map((entry)=>!!entry.message).includes(true);
        const canContinue = validRegFields && !hasErrors;
        if (!canContinue && errorStep >= 0) setRegFieldSelectedAttendee({
            stage: errorStep
        });
        if (canContinue) {
            return submitTabEventDetails();
        }
    };
    const handleEmailChange = (email)=>{
        setEmail(email);
        if (!hasAccount && !isNewLogin) checkEmail(email);
    };
    const vatIncluded = (0,register_util/* isVatIncludedForOrganisation */.xG)(event === null || event === void 0 ? void 0 : (ref16 = event.event) === null || ref16 === void 0 ? void 0 : ref16.organizationName);
    return {
        accountError,
        activeAdditionalTickets,
        allTicketsRegistrationFieldsAreFilled,
        alreadyJoined,
        attendeesError,
        attendeesToGetRegFields,
        availableTickets,
        clearForm,
        confirmPassword,
        continueFromAccountStep,
        continueFromTicketStep,
        currency,
        disableFormProgress,
        donationData,
        dynamicStyle,
        email,
        error,
        errorHandler,
        errors,
        event,
        eventId,
        eventImage,
        fieldVals,
        firstName,
        foundTicket,
        fundraise,
        fundraiseId,
        getAttendeesToGetRegFields,
        getEmail,
        handleAdditionalAttendeesContinue,
        handleAdditionalTicketChange,
        handleAdditionalTickets,
        handleEmailChange,
        handleGoogleSignIn,
        handleLinkedInSignIn,
        handleRegistrationFieldChange,
        handleRegistrationFieldNext,
        handleRegistrationFieldPrevious,
        handleRegistrationFieldsContinue,
        hasEnoughTickets,
        hasAccount,
        invoiceTicketTotal,
        isDarkTheme,
        isInvoiceTicket,
        isGroupGuestTicket,
        isNewLogin,
        isRegistrationVisible,
        lastName,
        loading,
        maxAdditionalTickets,
        organisationProfile,
        organisationTrxFee,
        password,
        profile,
        programmes,
        regFieldSelectedAttendee,
        router,
        saving,
        setAttendeesError,
        setAttendeesToGetRegFields,
        setConfirmPassword,
        setDonationData,
        setError,
        setErrors,
        setFieldVals,
        setFirstName,
        setHasAccount,
        setIsNewLogin,
        setIsRegistrationVisible,
        setLastName,
        setPassword,
        setRedirectTarget,
        setRegFieldSelectedAttendee,
        selectedTicketAllowsMultiple,
        setRequiresAdditionalTickets,
        setSaving,
        setTab,
        setTicketData,
        signedIn,
        signInWithEmail,
        syncAuthenticatedSession,
        stripePromise,
        stripeReady,
        submitTabEventDetails,
        tab,
        theme,
        ticketData,
        userData,
        vatIncluded,
        videoUrl
    };
};


/***/ }),

/***/ 87653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ CountInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6686);




/**
 * Primary UI component for count inputs.
 */ const CountInput = (param)=>{
    let { label , value =0 , onChange , className , validations , required , textColour , border ="border" , show =true , minValue =0 , maxValue =99 , error  } = param;
    const errorMessage = error !== null && error !== void 0 ? error : (0,_Validations__WEBPACK_IMPORTED_MODULE_3__/* .validate */ .G)(value, validations);
    const [count, setCount] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(value);
    const inputId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>label ? "count-input-".concat(label.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-")) : undefined, [
        label
    ]);
    const clampValue = (nextValue)=>{
        if (!Number.isFinite(nextValue)) return minValue;
        return Math.min(maxValue, Math.max(minValue, nextValue));
    };
    const updateCount = (nextValue)=>{
        const nextCount = clampValue(nextValue);
        setCount(nextCount);
        onChange && onChange(nextCount);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setCount(clampValue(value));
    }, [
        value,
        minValue,
        maxValue
    ]);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    const borderStyles = border === "border-none" ? "border-none" : "".concat(border, " ").concat(errorMessage ? "border-red-500 focus-within:border-red-500" : "border-gray-300 focus-within:border-forumm-blue");
    const buttonClassName = "flex h-11 w-11 items-center justify-center border-gray-300 text-lg font-semibold text-[#153e3e] transition-all hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#153e3e]/30 disabled:cursor-not-allowed disabled:text-gray-300 disabled:hover:bg-transparent";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        ignoreTheme: true,
        className: [
            "flex flex-col my-3",
            className
        ].join(" "),
        style: {
            color: textColour
        },
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: inputId,
                className: "mb-1.5 text-sm font-medium leading-5 text-[#153e3e] transition-all ".concat(errorMessage ? "text-red-500" : "", " ").concat(required ? "after:content-['*'] after:ml-1 after:text-red-500" : ""),
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "flex h-11 w-fit overflow-hidden rounded bg-white/70 transition-all ".concat(borderStyles),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        "aria-label": "Decrease ".concat(label !== null && label !== void 0 ? label : "value"),
                        className: "".concat(buttonClassName, " border-r"),
                        disabled: count <= minValue,
                        onClick: ()=>{
                            updateCount(count - 1);
                        },
                        children: "-"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        id: inputId,
                        required: required,
                        value: Number.isNaN(count) ? "" : count,
                        onChange: (e)=>{
                            updateCount(parseInt(e.target.value, 10));
                        },
                        min: minValue,
                        max: maxValue,
                        type: "number",
                        className: "h-11 w-14 bg-transparent px-2 py-2 text-center text-sm font-medium text-[#153e3e] outline-none transition-all placeholder-gray-500 focus:ring-0 ".concat(errorMessage ? "text-red-500" : "")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        "aria-label": "Increase ".concat(label !== null && label !== void 0 ? label : "value"),
                        className: "".concat(buttonClassName, " border-l"),
                        disabled: count >= maxValue,
                        onClick: ()=>{
                            updateCount(count + 1);
                        },
                        children: "+"
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "mt-1 text-sm font-bold text-red-500",
                children: errorMessage
            })
        ]
    });
};


/***/ }),

/***/ 26291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47906);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39618);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var voca__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81209);
/* harmony import */ var _ColorPicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14857);
/* harmony import */ var _DateTimeInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8194);
/* harmony import */ var _DropdownInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61993);
/* harmony import */ var _FileInput__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40296);
/* harmony import */ var _PriceInput__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84456);
/* harmony import */ var _TextAreaInput__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33923);













const formElements = {
    FileInput: _FileInput__WEBPACK_IMPORTED_MODULE_10__/* .FileInput */ .S,
    DateTimeInput: _DateTimeInput__WEBPACK_IMPORTED_MODULE_8__/* .DateTimeInput */ .Y,
    TextInput: _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o,
    PriceInput: _PriceInput__WEBPACK_IMPORTED_MODULE_11__/* .PriceInput */ .t,
    TextAreaInput: _TextAreaInput__WEBPACK_IMPORTED_MODULE_12__/* .TextAreaInput */ .F,
    DropdownInput: _DropdownInput__WEBPACK_IMPORTED_MODULE_9__/* .DropdownInput */ .f,
    ColorPicker: _ColorPicker__WEBPACK_IMPORTED_MODULE_7__/* .ColorPicker */ .z
};
const INPUT_ELEMENTS = [
    "CheckboxInput",
    "DropdownInput"
];
const isProtectedInput = (element)=>{
    var ref, ref1;
    // if ((element.type as any).name === 'CheckboxInput') console.log({ element })
    if ((ref = element.props) === null || ref === void 0 ? void 0 : ref.isProtected) return true;
    if ((ref1 = element.type) === null || ref1 === void 0 ? void 0 : ref1.name) {
        return INPUT_ELEMENTS.includes(element.type.name);
    }
};
const getFormData = function(children, formData, setFormData) {
    let initialFormData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    children.forEach((element, i)=>{
        var ref;
        if ((element === null || element === void 0 ? void 0 : (ref = element.props) === null || ref === void 0 ? void 0 : ref.children) && !isProtectedInput(element)) {
            const { children: childElements  } = element.props;
            if (childElements) {
                const newChildren = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.isArray)(childElements) ? [
                    ...childElements
                ] : [
                    childElements
                ];
                initialFormData = {
                    ...initialFormData,
                    ...getFormData(newChildren, formData, setFormData, initialFormData)
                };
                children[i] = children[i].type == _components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    ...element.props,
                    children: newChildren
                }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    ...element.props,
                    children: newChildren
                }, i);
            }
        } else {
            var ref1;
            if (!(element === null || element === void 0 ? void 0 : (ref1 = element.props) === null || ref1 === void 0 ? void 0 : ref1.label)) return;
            const { label , required , onChange: existingOnChange  } = element.props;
            const camelCaseLabel = voca__WEBPACK_IMPORTED_MODULE_6__/* ["default"].camelCase */ .Z.camelCase(label);
            // console.log({ camelCaseLabel })
            if (camelCaseLabel == null || camelCaseLabel === "") {
                children[i] = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.cloneElement)(element, {
                    ...element.props,
                    key: i
                });
            } else {
                var ref2;
                children[i] = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.cloneElement)(element, {
                    ...element.props,
                    key: i,
                    value: formData.hasOwnProperty(camelCaseLabel !== null && camelCaseLabel !== void 0 ? camelCaseLabel : "") ? (ref2 = formData[camelCaseLabel !== null && camelCaseLabel !== void 0 ? camelCaseLabel : ""]) === null || ref2 === void 0 ? void 0 : ref2.value : undefined,
                    onChange: (value, invalidData)=>{
                        const isInvalid = [
                            required && value === undefined,
                            invalidData
                        ].some((val)=>val === true);
                        // console.log({ isInvalid })
                        setFormData((currentFormData)=>({
                                ...currentFormData,
                                [camelCaseLabel]: {
                                    value: value,
                                    invalid: isInvalid
                                }
                            }));
                        existingOnChange && existingOnChange(value, invalidData);
                    }
                });
                initialFormData = {
                    ...initialFormData,
                    [camelCaseLabel]: {
                        value: undefined,
                        invalid: required === true
                    }
                };
            }
        }
    });
    return initialFormData;
};
/**
 * Primary UI component for Forms
 */ const Form = (param)=>{
    let { className , children , onSubmit , initialFormData , error , clearFormOnSubmit =false , clearFormOnError =false , clearForm , show =true , ...rest } = param;
    let modifiedChildren = [
        ...children
    ];
    const getInitialFormData = ()=>{
        if (initialFormData) {
            const normalizedFormData = Object.keys(initialFormData).reduce((acc, key)=>{
                acc[key] = {
                    value: initialFormData[key],
                    invalid: false
                };
                return acc;
            }, {});
            getFormData(modifiedChildren, normalizedFormData, ()=>{});
            return normalizedFormData;
        } else {
            return getFormData(modifiedChildren, {}, ()=>{});
        }
    };
    const [formData, setFormData] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(getInitialFormData());
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        if (!!clearForm) setFormData(getInitialFormData());
    }, [
        clearForm
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        setFormData(getInitialFormData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        setErrorMessage(error || "");
    }, [
        error
    ]);
    getFormData(modifiedChildren, formData, setFormData);
    const [errorMessage, setErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const invalidForm = Object.values(formData).some((element)=>element.invalid);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        ...rest,
        className: className !== null && className !== void 0 ? className : "",
        onSubmit: async (e)=>{
            e.preventDefault();
            // console.log({ fd: Object.values(formData) })
            if (invalidForm) {
                setErrorMessage("One or more fields are invalid or missing");
                if (clearFormOnError) {
                    setFormData(getInitialFormData());
                }
                return;
            }
            if (onSubmit) {
                const formDataValues = Object.entries(formData).reduce((acc, param)=>{
                    let [key, value] = param;
                    return {
                        ...acc,
                        [voca__WEBPACK_IMPORTED_MODULE_6__/* ["default"].camelCase */ .Z.camelCase(key)]: value.value
                    };
                }, {});
                const errorMessage = await onSubmit(formDataValues);
                if (errorMessage) {
                    setErrorMessage(errorMessage);
                }
            }
            if (clearFormOnSubmit) {
                setFormData(getInitialFormData());
            }
        },
        children: [
            modifiedChildren,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                show: !!errorMessage || !!invalidForm,
                ignoreTheme: true,
                className: "flex justify-center items-center text-center transition-all ".concat(errorMessage || invalidForm ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold mb-6 sm:mt-0 md:mt-8"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "One or more fields are invalid"
            })
        ]
    });
};


/***/ }),

/***/ 33923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ TextAreaInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5779);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6686);





/**
 * Primary UI component for text input
 */ const TextAreaInput = (param)=>{
    let { label , placeholder , value ="" , onChange , onKeyDown , className , rows , hint , validations , required , testid , show =true , labelBgColour , preventBorder =false , dynamicResize =false , preventResize =false , setError  } = param;
    const parsedValidations = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultValidations */ .C)(undefined, validations);
    let errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(value, parsedValidations);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        onLoad();
    }, []);
    const onLoad = ()=>{
        if (!show) return;
        handleDynamicResize();
    };
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (value === null) value = "";
    function handleDynamicResize(e) {
        if (dynamicResize && ref.current) {
            ref.current.style.height = "auto";
            ref.current.style.height = ref.current.scrollHeight + "px";
        }
    }
    function handleKeyDown(e) {
        onKeyDown && onKeyDown(e);
        if (e.isDefaultPrevented() && ref.current) ref.current.style.height = "auto";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: [
            "flex flex-col",
            className
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute text-sm -translate-y-1/2 mb-2 ml-2 ".concat(required ? "pl-2" : "px-2", " transition-all ").concat(errorMessage ? "text-red-500" : ""),
                style: {
                    backgroundColor: labelBgColour ? labelBgColour : theme.backgroundColour
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: required ? "after:content-['*'] after:mx-2 after:text-red-500" : "",
                    children: label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                required: required,
                value: value,
                onChange: (e)=>{
                    errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(e.target.value, parsedValidations);
                    // setErrorMessage(errorMsg ?? '')
                    const isInvalid = errorMessage !== "";
                    var ref;
                    if (!!setError) setError(errorMessage, (ref = testid !== null && testid !== void 0 ? testid : label) !== null && ref !== void 0 ? ref : "unknown");
                    onChange && onChange(e.target.value, isInvalid);
                    handleDynamicResize(e);
                },
                rows: rows !== null && rows !== void 0 ? rows : 3,
                autoComplete: "on",
                placeholder: placeholder,
                className: "transition-all bg-transparent ".concat(preventBorder ? "" : "border", " ").concat(errorMessage ? "text-red-500 border-red-500" : "", " ").concat(preventResize ? "resize-none" : "", " rounded px-4 py-4 text-sm outline-none"),
                "data-testid": testid !== null && testid !== void 0 ? testid : null,
                onKeyDown: handleKeyDown,
                ref: ref
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-1 mb-4 ml-2 text-xs",
                children: hint
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "-"
            })
        ]
    });
};


/***/ }),

/***/ 59832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ TicketDropdownInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68240);
/* harmony import */ var _libs_currencies__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30530);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





const getTicketPrice = (ticketTitle, ticketDetails)=>{
    return ticketDetails === null || ticketDetails === void 0 ? void 0 : ticketDetails.find((ticket)=>{
        return ticket.title.toUpperCase() === (ticketTitle === null || ticketTitle === void 0 ? void 0 : ticketTitle.toUpperCase());
    });
};
const ticketHasDiscounts = (ticket)=>{
    var ref;
    return !!(ticket === null || ticket === void 0 ? void 0 : ticket.discountCodes) && (ticket === null || ticket === void 0 ? void 0 : (ref = ticket.discountCodes) === null || ref === void 0 ? void 0 : ref.length) > 0;
};
const getDiscountsRemaining = (ticket)=>{
    var ref;
    var ref1;
    return (ref1 = (ref = ticket.discountCodes) === null || ref === void 0 ? void 0 : ref.reduce((total, discount)=>{
        var ref;
        return total + ((ref = discount === null || discount === void 0 ? void 0 : discount.remaining) !== null && ref !== void 0 ? ref : 0);
    }, 0)) !== null && ref1 !== void 0 ? ref1 : 0;
};
const isNoCheckoutTicket = (ticket)=>{
    return (ticket === null || ticket === void 0 ? void 0 : ticket.ticketType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .TicketType.Free */ .zK.Free || (ticket === null || ticket === void 0 ? void 0 : ticket.ticketType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .TicketType.InvoiceTicket */ .zK.InvoiceTicket || (ticket === null || ticket === void 0 ? void 0 : ticket.price) === 0;
};
const SHOW_DISCOUNTS = false;
const REMAINING_TICKET_THRESHOLD = 20;
const TicketDropdownInput = (param)=>{
    let { label ="Ticket Type" , tickets , ticketDetails , currency ="GBP" , value , show =true , required =false , onChange  } = param;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var ref;
    const currencyDetails = (ref = _libs_currencies__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[currency.toUpperCase()]) !== null && ref !== void 0 ? ref : _libs_currencies__WEBPACK_IMPORTED_MODULE_3__/* ["default"].GBP */ .Z.GBP;
    const selectedTicket = value ? tickets.find((ticket)=>{
        var ref;
        return ((ref = ticket.ticketTitle) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === (value === null || value === void 0 ? void 0 : value.toUpperCase());
    }) : undefined;
    const dropdownTickets = selectedTicket && tickets.length > 1 ? tickets.filter((ticket)=>{
        var ref, ref1;
        return ((ref = ticket.ticketTitle) === null || ref === void 0 ? void 0 : ref.toUpperCase()) !== ((ref1 = selectedTicket.ticketTitle) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase());
    }) : tickets;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (!open) return;
        const handleClickOutside = (event)=>{
            var ref;
            if (!((ref = dropdownRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target))) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        open
    ]);
    if (!show) return null;
    const formatTicket = (ticket)=>{
        var _ticketTitle;
        const title = (_ticketTitle = ticket.ticketTitle) !== null && _ticketTitle !== void 0 ? _ticketTitle : "";
        const details = getTicketPrice(title, ticketDetails);
        const isWaitingList = (details === null || details === void 0 ? void 0 : details.ticketType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .TicketType.WaitingList */ .zK.WaitingList;
        var _remaining;
        const remainingCount = parseInt((_remaining = ticket.remaining) !== null && _remaining !== void 0 ? _remaining : "0", 10);
        const isSoldOut = !isWaitingList && remainingCount < 1;
        const hasDiscounts = ticketHasDiscounts(ticket);
        const discountsRemaining = getDiscountsRemaining(ticket);
        var ref;
        const formattedPrice = "".concat(currencyDetails.symbol).concat(((ref = details === null || details === void 0 ? void 0 : details.price) !== null && ref !== void 0 ? ref : 0).toFixed(2));
        const priceLabel = (details === null || details === void 0 ? void 0 : details.ticketType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .TicketType.InvoiceTicket */ .zK.InvoiceTicket ? "".concat(formattedPrice, " invoiced later") : isNoCheckoutTicket(details) ? "Free" : formattedPrice;
        return {
            hasDiscounts,
            discountsRemaining,
            isSoldOut,
            isWaitingList,
            priceLabel,
            remainingLabel: isWaitingList ? "Waiting list" : isSoldOut ? "Sold out" : remainingCount > REMAINING_TICKET_THRESHOLD ? "Available" : "".concat(remainingCount, " Left"),
            title
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "relative z-50 mb-4 flex flex-col space-y-2",
        innerRef: dropdownRef,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "text-sm font-medium",
                children: [
                    label,
                    required ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "ml-1 text-red-500",
                        children: "*"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: ()=>setOpen((state)=>!state),
                className: "w-full rounded border border-gray-300 bg-white p-3 text-left text-gray-900 transition-all hover:border-forumm-blue",
                children: selectedTicket ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TicketDropdownItem, {
                    ...formatTicket(selectedTicket)
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    className: "flex items-center justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    className: "font-semibold leading-tight",
                                    children: "Select a ticket"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    className: "mt-1 text-sm opacity-75",
                                    children: "Choose from available ticket options"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "rounded-full bg-gray-100 px-2 py-1 text-[11px] font-medium text-gray-700",
                            children: "Required"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "".concat(open ? "absolute top-full z-50 mt-1" : "hidden", " flex max-h-80 w-full flex-col gap-2 overflow-y-auto rounded border border-gray-300 bg-white p-2 text-gray-900 shadow-xl"),
                children: dropdownTickets.map((ticket)=>{
                    var ref;
                    const ticketDisplay = formatTicket(ticket);
                    const { isSoldOut , title  } = ticketDisplay;
                    const selected = title.toUpperCase() === (selectedTicket === null || selectedTicket === void 0 ? void 0 : (ref = selectedTicket.ticketTitle) === null || ref === void 0 ? void 0 : ref.toUpperCase());
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        disabled: isSoldOut,
                        onClick: ()=>{
                            onChange === null || onChange === void 0 ? void 0 : onChange(title.toUpperCase());
                            setOpen(false);
                        },
                        className: "w-full rounded border p-3 text-left transition-all ".concat(selected ? "border-forumm-blue bg-forumm-blue/10" : "border-gray-200 bg-white hover:border-forumm-blue", " ").concat(isSoldOut ? "cursor-not-allowed border-red-100 bg-red-50" : ticketDisplay.isWaitingList ? "cursor-pointer border-amber-200 bg-amber-50" : "cursor-pointer"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TicketDropdownItem, {
                            ...ticketDisplay
                        })
                    }, title);
                })
            })
        ]
    });
};
const TicketDropdownItem = (param)=>/*#__PURE__*/ {
    let { hasDiscounts , discountsRemaining , isSoldOut , isWaitingList , priceLabel , remainingLabel , title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "flex items-start justify-between gap-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "min-w-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "font-semibold leading-tight ".concat(isSoldOut ? "text-gray-500 line-through" : "", " ").concat(isWaitingList ? "text-amber-900" : ""),
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "mt-1 text-sm opacity-75",
                        children: priceLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "flex shrink-0 flex-wrap justify-end gap-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "rounded-full px-2 py-1 text-[11px] font-medium ".concat(isSoldOut ? "bg-red-100 text-red-700" : isWaitingList ? "bg-amber-100 text-amber-800" : "bg-gray-100 text-gray-700"),
                        children: remainingLabel
                    }),
                    !isWaitingList && hasDiscounts && SHOW_DISCOUNTS && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "rounded-full px-2 py-1 text-[11px] font-medium ".concat(discountsRemaining > 0 ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"),
                        children: discountsRemaining > 0 ? "Discounts Available" : "No discounts"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 87755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ GET_EVENT_BY_ID; }
/* harmony export */ });
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66703);

const GET_EVENT_BY_ID = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  query getEventById($input: GetEventByIdInput!) {\n    getEventById(input: $input) {\n      ...EventFull\n    }\n  }\n");


/***/ })

}]);